import { EntryTypes, ModuleTypes, PageTypes, IConfigPage, IItem, IWelcomePage, IBusiness, DOOR_FUNCTION, DOOR_STATE, PERSON_TYPE, GUEST_TYPE, IPerson, IDoorList, IMultiProperties } from "src/app/metadata/interfaces/page/Pages";



EntryTypes

export class skyaccessData {

  public static DefaultItems = [
    {
      "SkyAccessDesignID": 1,
      "ID": "HeaderColor",
      "StaticTxt": "Header Color",
      "VarTxt": null,
      "Color": "#ffffff",
      "BgColor": null,
      "PageType": 9,
      "EntryType": 1,
      "ModuleType": 3,
      "Enabled": true,
      "Links": null,
      "Classes": null,
      "Longitude": null,
      "Latitude": null,
      "StatTranslate": null,
      "FontSz": null,
      "_CreationDate": null,
      "_UpdatedDate": null,
      "_SysNumber": 286331154
    },
    {
      "SkyAccessDesignID": 2,
      "ID": "HeaderBgColor",
      "StaticTxt": "Header background Color and Opacity",
      "VarTxt": null,
      "Color": "",
      "BgColor": "rgb(0,40,0,0.5)",
      "PageType": 9,
      "EntryType": 2,
      "ModuleType": 3,
      "Enabled": true,
      "Links": null,
      "Classes": null,
      "Longitude": null,
      "Latitude": null,
      "StatTranslate": null,
      "FontSz": null,
      "_CreationDate": null,
      "_UpdatedDate": null,
      "_SysNumber": 286331154
    },
    {
      "SkyAccessDesignID": 3,
      "ID": "HeaderIcon",
      "StaticTxt": "Header Icon 20x144px",
      "VarTxt": null,
      "Color": null,
      "BgColor": null,
      "PageType": 9,
      "EntryType": 0,
      "ModuleType": 3,
      "Enabled": true,
      "Links": null,
      "Classes": null,
      "Longitude": null,
      "Latitude": null,
      "StatTranslate": null,
      "FontSz": null,
      "_CreationDate": null,
      "_UpdatedDate": null,
      "_SysNumber": 286331154
    },
    {
      "SkyAccessDesignID": 4,
      "ID": "ShowHeaderIcon",
      "StaticTxt": "Show header icon",
      "VarTxt": null,
      "Color": null,
      "BgColor": null,
      "PageType": 9,
      "EntryType": 0,
      "ModuleType": 3,
      "Enabled": true,
      "Links": null,
      "Classes": null,
      "Longitude": null,
      "Latitude": null,
      "StatTranslate": null,
      "FontSz": null,
      "_CreationDate": null,
      "_UpdatedDate": null,
      "_SysNumber": 286331154
    },
    {
      "SkyAccessDesignID": 5,
      "ID": "HeaderTitle",
      "StaticTxt": "Modify header title :",
      "VarTxt": ".SKYACCESS.",
      "Color": null,
      "BgColor": null,
      "PageType": 9,
      "EntryType": 0,
      "ModuleType": 3,
      "Enabled": true,
      "Links": null,
      "Classes": null,
      "Longitude": null,
      "Latitude": null,
      "StatTranslate": null,
      "FontSz": null,
      "_CreationDate": null,
      "_UpdatedDate": null,
      "_SysNumber": 286331154
    },
    {
      "SkyAccessDesignID": 6,
      "ID": "HeaderFixed",
      "StaticTxt": "Header fixed : ",
      "VarTxt": null,
      "Color": null,
      "BgColor": null,
      "PageType": 9,
      "EntryType": 0,
      "ModuleType": 3,
      "Enabled": true,
      "Links": null,
      "Classes": null,
      "Longitude": null,
      "Latitude": null,
      "StatTranslate": null,
      "FontSz": null,
      "_CreationDate": null,
      "_UpdatedDate": null,
      "_SysNumber": 286331154
    },
    {
      "SkyAccessDesignID": 7,
      "ID": "MainMenuColor",
      "StaticTxt": "Main menu Color",
      "VarTxt": "",
      "Color": "#ffffff",
      "BgColor": null,
      "PageType": 9,
      "EntryType": 1,
      "ModuleType": 4,
      "Enabled": true,
      "Links": null,
      "Classes": null,
      "Longitude": null,
      "Latitude": null,
      "StatTranslate": null,
      "FontSz": null,
      "_CreationDate": null,
      "_UpdatedDate": null,
      "_SysNumber": 286331154
    },
    {
      "SkyAccessDesignID": 8,
      "ID": "MainMenuBgColor",
      "StaticTxt": "Main menu background Color and Opacity",
      "VarTxt": null,
      "Color": null,
      "BgColor": "rgb(0,20,40,0.5)",
      "PageType": 9,
      "EntryType": 2,
      "ModuleType": 4,
      "Enabled": true,
      "Links": null,
      "Classes": null,
      "Longitude": null,
      "Latitude": null,
      "StatTranslate": null,
      "FontSz": null,
      "_CreationDate": null,
      "_UpdatedDate": null,
      "_SysNumber": 286331154
    },
    {
      "SkyAccessDesignID": 9,
      "ID": "BgImage",
      "StaticTxt": "Main menu background image 20x200px",
      "VarTxt": null,
      "Color": null,
      "BgColor": null,
      "PageType": 9,
      "EntryType": 0,
      "ModuleType": 4,
      "Enabled": true,
      "Links": null,
      "Classes": null,
      "Longitude": null,
      "Latitude": null,
      "StatTranslate": null,
      "FontSz": null,
      "_CreationDate": null,
      "_UpdatedDate": null,
      "_SysNumber": 286331154
    },
    {
      "SkyAccessDesignID": 10,
      "ID": "MmFixed",
      "StaticTxt": "Main menu fixed : ",
      "VarTxt": null,
      "Color": null,
      "BgColor": null,
      "PageType": 9,
      "EntryType": 0,
      "ModuleType": 4,
      "Enabled": true,
      "Links": null,
      "Classes": null,
      "Longitude": null,
      "Latitude": null,
      "StatTranslate": null,
      "FontSz": null,
      "_CreationDate": null,
      "_UpdatedDate": null,
      "_SysNumber": 286331154
    },
    {
      "SkyAccessDesignID": 11,
      "ID": "KmColor",
      "StaticTxt": "Key menu Color",
      "VarTxt": null,
      "Color": "#ffffff",
      "BgColor": null,
      "PageType": 9,
      "EntryType": 1,
      "ModuleType": 4,
      "Enabled": true,
      "Links": null,
      "Classes": null,
      "Longitude": null,
      "Latitude": null,
      "StatTranslate": null,
      "FontSz": null,
      "_CreationDate": null,
      "_UpdatedDate": null,
      "_SysNumber": 286331154
    },
    {
      "SkyAccessDesignID": 12,
      "ID": "KmBgColor",
      "StaticTxt": "Header background Color and Opacity",
      "VarTxt": null,
      "Color": null,
      "BgColor": "rgb(0,40,0,1)",
      "PageType": 9,
      "EntryType": 2,
      "ModuleType": 4,
      "Enabled": true,
      "Links": null,
      "Classes": null,
      "Longitude": null,
      "Latitude": null,
      "StatTranslate": null,
      "FontSz": null,
      "_CreationDate": null,
      "_UpdatedDate": null,
      "_SysNumber": 286331154
    },
    {
      "SkyAccessDesignID": 13,
      "ID": "MmMuliprop",
      "StaticTxt": "Multi-Properties:",
      "VarTxt": "Multi-Properties",
      "Color": null,
      "BgColor": null,
      "PageType": 7,
      "EntryType": 0,
      "ModuleType": 0,
      "Enabled": true,
      "Links": null,
      "Classes": "feather icon-cloud",
      "Longitude": null,
      "Latitude": null,
      "StatTranslate": null,
      "FontSz": null,
      "_CreationDate": null,
      "_UpdatedDate": null,
      "_SysNumber": 286331154
    },
    {
      "SkyAccessDesignID": 14,
      "ID": "MmHome",
      "StaticTxt": "Home :",
      "VarTxt": "Home",
      "Color": null,
      "BgColor": null,
      "PageType": 7,
      "EntryType": 0,
      "ModuleType": 0,
      "Enabled": true,
      "Links": null,
      "Classes": "feather icon-home",
      "Longitude": null,
      "Latitude": null,
      "StatTranslate": null,
      "FontSz": null,
      "_CreationDate": null,
      "_UpdatedDate": null,
      "_SysNumber": 286331154
    },
    {
      "SkyAccessDesignID": 15,
      "ID": "MmHotel",
      "StaticTxt": "Hotel :",
      "VarTxt": "Hotel",
      "Color": null,
      "BgColor": null,
      "PageType": 7,
      "EntryType": 0,
      "ModuleType": 0,
      "Enabled": true,
      "Links": null,
      "Classes": "fa fa-building",
      "Longitude": null,
      "Latitude": null,
      "StatTranslate": null,
      "FontSz": null,
      "_CreationDate": null,
      "_UpdatedDate": null,
      "_SysNumber": 286331154
    },
    {
      "SkyAccessDesignID": 16,
      "ID": "MmGuide",
      "StaticTxt": "City Guide :",
      "VarTxt": "City Guide",
      "Color": null,
      "BgColor": null,
      "PageType": 7,
      "EntryType": 0,
      "ModuleType": 0,
      "Enabled": true,
      "Links": null,
      "Classes": "fa fa-city",
      "Longitude": null,
      "Latitude": null,
      "StatTranslate": null,
      "FontSz": null,
      "_CreationDate": null,
      "_UpdatedDate": null,
      "_SysNumber": 286331154
    },
    {
      "SkyAccessDesignID": 17,
      "ID": "ShareOnFb",
      "StaticTxt": "Share on facebook :",
      "VarTxt": "Facebook",
      "Color": null,
      "BgColor": null,
      "PageType": 7,
      "EntryType": 0,
      "ModuleType": 0,
      "Enabled": true,
      "Links": "https://www.facebook.com/amadeosystems",
      "Classes": "fab fa-facebook",
      "Longitude": null,
      "Latitude": null,
      "StatTranslate": null,
      "FontSz": null,
      "_CreationDate": null,
      "_UpdatedDate": null,
      "_SysNumber": 286331154
    },
    {
      "SkyAccessDesignID": 18,
      "ID": "ShareOnTTr",
      "StaticTxt": "follow on twitter :",
      "VarTxt": "Twitter",
      "Color": null,
      "BgColor": null,
      "PageType": 7,
      "EntryType": 0,
      "ModuleType": 0,
      "Enabled": true,
      "Links": "https://twitter.com/amadeosystems/",
      "Classes": "fab fa-twitter",
      "Longitude": null,
      "Latitude": null,
      "StatTranslate": null,
      "FontSz": null,
      "_CreationDate": null,
      "_UpdatedDate": null,
      "_SysNumber": 286331154
    },
    {
      "SkyAccessDesignID": 19,
      "ID": "HomeScreen",
      "StaticTxt": "Allow the user to add the app to the home screen : ",
      "VarTxt": null,
      "Color": null,
      "BgColor": null,
      "PageType": 7,
      "EntryType": 0,
      "ModuleType": 0,
      "Enabled": true,
      "Links": null,
      "Classes": "fas fa-home",
      "Longitude": null,
      "Latitude": null,
      "StatTranslate": null,
      "FontSz": null,
      "_CreationDate": null,
      "_UpdatedDate": null,
      "_SysNumber": 286331154
    },
    {
      "SkyAccessDesignID": 20,
      "ID": "business-module-1000",
      "StaticTxt": "Module 1:",
      "VarTxt": "In House",
      "Color": null,
      "BgColor": null,
      "PageType": 8,
      "EntryType": 0,
      "ModuleType": 1,
      "Enabled": true,
      "Links": "../../../../assets/images/bg-images/old/bg4.jpg",
      "Classes": null,
      "Longitude": null,
      "Latitude": null,
      "StatTranslate": null,
      "FontSz": null,
      "_CreationDate": null,
      "_UpdatedDate": null,
      "_SysNumber": 286331154
    },
    {
      "SkyAccessDesignID": 21,
      "ID": "business-module-10000",
      "StaticTxt": "Module 2:",
      "VarTxt": "Rooms & Suites",
      "Color": null,
      "BgColor": null,
      "PageType": 8,
      "EntryType": 0,
      "ModuleType": 1,
      "Enabled": true,
      "Links": "../../../../assets/images/bg-images/old/bg3.jpg",
      "Classes": null,
      "Longitude": null,
      "Latitude": null,
      "StatTranslate": null,
      "FontSz": null,
      "_CreationDate": null,
      "_UpdatedDate": null,
      "_SysNumber": 286331154
    },
    {
      "SkyAccessDesignID": 22,
      "ID": "business-module-100000",
      "StaticTxt": "Module 3:",
      "VarTxt": "Restaurant",
      "Color": null,
      "BgColor": null,
      "PageType": 8,
      "EntryType": 0,
      "ModuleType": 1,
      "Enabled": true,
      "Links": "../../../../assets/images/bg-images/old/bg4.jpg",
      "Classes": null,
      "Longitude": null,
      "Latitude": null,
      "StatTranslate": null,
      "FontSz": null,
      "_CreationDate": null,
      "_UpdatedDate": null,
      "_SysNumber": 286331154
    },
    {
      "SkyAccessDesignID": 23,
      "ID": "business-module-2000",
      "StaticTxt": "Module 4:",
      "VarTxt": "Room Services",
      "Color": null,
      "BgColor": null,
      "PageType": 8,
      "EntryType": 0,
      "ModuleType": 1,
      "Enabled": true,
      "Links": "../../../../assets/images/bg-images/old/bg5.jpg",
      "Classes": null,
      "Longitude": null,
      "Latitude": null,
      "StatTranslate": null,
      "FontSz": null,
      "_CreationDate": null,
      "_UpdatedDate": null,
      "_SysNumber": 286331154
    },
    {
      "SkyAccessDesignID": 24,
      "ID": "business-module-20000",
      "StaticTxt": "Module 5:",
      "VarTxt": "BAR",
      "Color": null,
      "BgColor": null,
      "PageType": 8,
      "EntryType": 0,
      "ModuleType": 1,
      "Enabled": true,
      "Links": "../../../../assets/images/bg-images/old/bg1.jpg",
      "Classes": null,
      "Longitude": null,
      "Latitude": null,
      "StatTranslate": null,
      "FontSz": null,
      "_CreationDate": null,
      "_UpdatedDate": null,
      "_SysNumber": 286331154
    },
    {
      "SkyAccessDesignID": 25,
      "ID": "business-module-200000",
      "StaticTxt": "Module 6:",
      "VarTxt": "Fitness",
      "Color": null,
      "BgColor": null,
      "PageType": 8,
      "EntryType": 0,
      "ModuleType": 1,
      "Enabled": true,
      "Links": "../../../../assets/images/bg-images/old/bg3.jpg",
      "Classes": null,
      "Longitude": null,
      "Latitude": null,
      "StatTranslate": null,
      "FontSz": null,
      "_CreationDate": null,
      "_UpdatedDate": null,
      "_SysNumber": 286331154
    },
    {
      "SkyAccessDesignID": 26,
      "ID": "business-module-20000000",
      "StaticTxt": "Module 7:",
      "VarTxt": "SPA",
      "Color": null,
      "BgColor": null,
      "PageType": 8,
      "EntryType": 0,
      "ModuleType": 1,
      "Enabled": true,
      "Links": "../../../../assets/images/bg-images/old/bg4.jpg",
      "Classes": null,
      "Longitude": null,
      "Latitude": null,
      "StatTranslate": null,
      "FontSz": null,
      "_CreationDate": null,
      "_UpdatedDate": null,
      "_SysNumber": 286331154
    },
    {
      "SkyAccessDesignID": 27,
      "ID": "ColorHead",
      "StaticTxt": "Title Color:",
      "VarTxt": null,
      "Color": "#ffffff",
      "BgColor": null,
      "PageType": 8,
      "EntryType": 1,
      "ModuleType": 1,
      "Enabled": true,
      "Links": null,
      "Classes": null,
      "Longitude": null,
      "Latitude": null,
      "StatTranslate": null,
      "FontSz": null,
      "_CreationDate": null,
      "_UpdatedDate": null,
      "_SysNumber": 286331154
    },
    {
      "SkyAccessDesignID": 28,
      "ID": "BgColorHead",
      "StaticTxt": "Background color:",
      "VarTxt": null,
      "Color": null,
      "BgColor": "rgb(0,0,0,1)",
      "PageType": 8,
      "EntryType": 2,
      "ModuleType": 1,
      "Enabled": true,
      "Links": null,
      "Classes": null,
      "Longitude": null,
      "Latitude": null,
      "StatTranslate": null,
      "FontSz": null,
      "_CreationDate": null,
      "_UpdatedDate": null,
      "_SysNumber": 286331154
    },
    {
      "SkyAccessDesignID": 29,
      "ID": "guide-module-1000",
      "StaticTxt": "Guide 1:",
      "VarTxt": "Shopping",
      "Color": null,
      "BgColor": null,
      "PageType": 8,
      "EntryType": 0,
      "ModuleType": 2,
      "Enabled": true,
      "Links": "../../../../assets/images/bg-images/old/bg45.jpg",
      "Classes": null,
      "Longitude": null,
      "Latitude": null,
      "StatTranslate": null,
      "FontSz": null,
      "_CreationDate": null,
      "_UpdatedDate": null,
      "_SysNumber": 286331154
    },
    {
      "SkyAccessDesignID": 30,
      "ID": "guide-module-10000",
      "StaticTxt": "Guide 2:",
      "VarTxt": "Restaurants",
      "Color": null,
      "BgColor": null,
      "PageType": 8,
      "EntryType": 0,
      "ModuleType": 2,
      "Enabled": true,
      "Links": "../../../../assets/images/bg-images/old/bg3.jpg",
      "Classes": null,
      "Longitude": null,
      "Latitude": null,
      "StatTranslate": null,
      "FontSz": null,
      "_CreationDate": null,
      "_UpdatedDate": null,
      "_SysNumber": 286331154
    },
    {
      "SkyAccessDesignID": 31,
      "ID": "guide-module-100000",
      "StaticTxt": "Guide 3:",
      "VarTxt": "Night Life",
      "Color": null,
      "BgColor": null,
      "PageType": 8,
      "EntryType": 0,
      "ModuleType": 2,
      "Enabled": true,
      "Links": "../../../../assets/images/bg-images/old/bg4.jpg",
      "Classes": null,
      "Longitude": null,
      "Latitude": null,
      "StatTranslate": null,
      "FontSz": null,
      "_CreationDate": null,
      "_UpdatedDate": null,
      "_SysNumber": 286331154
    },
    {
      "SkyAccessDesignID": 32,
      "ID": "guide-module-2000",
      "StaticTxt": "Guide 4:",
      "VarTxt": "Kids Zone",
      "Color": null,
      "BgColor": null,
      "PageType": 8,
      "EntryType": 0,
      "ModuleType": 2,
      "Enabled": true,
      "Links": "../../../../assets/images/bg-images/old/bg5.jpg",
      "Classes": null,
      "Longitude": null,
      "Latitude": null,
      "StatTranslate": null,
      "FontSz": null,
      "_CreationDate": null,
      "_UpdatedDate": null,
      "_SysNumber": 286331154
    },
    {
      "SkyAccessDesignID": 33,
      "ID": "guide-module-20000",
      "StaticTxt": "Guide 5:",
      "VarTxt": "Neighborhood",
      "Color": null,
      "BgColor": null,
      "PageType": 8,
      "EntryType": 0,
      "ModuleType": 2,
      "Enabled": true,
      "Links": "../../../../assets/images/bg-images/old/bg1.jpg",
      "Classes": null,
      "Longitude": null,
      "Latitude": null,
      "StatTranslate": null,
      "FontSz": null,
      "_CreationDate": null,
      "_UpdatedDate": null,
      "_SysNumber": 286331154
    },
    {
      "SkyAccessDesignID": 34,
      "ID": "guide-module-200000",
      "StaticTxt": "Guide 6:",
      "VarTxt": "Must Know",
      "Color": null,
      "BgColor": null,
      "PageType": 8,
      "EntryType": 0,
      "ModuleType": 2,
      "Enabled": true,
      "Links": "../../../../assets/images/bg-images/old/bg3.jpg",
      "Classes": null,
      "Longitude": null,
      "Latitude": null,
      "StatTranslate": null,
      "FontSz": null,
      "_CreationDate": null,
      "_UpdatedDate": null,
      "_SysNumber": 286331154
    },
    {
      "SkyAccessDesignID": 35,
      "ID": "guide-module-20000000",
      "StaticTxt": "Guide 7:",
      "VarTxt": "Mechandises",
      "Color": null,
      "BgColor": null,
      "PageType": 8,
      "EntryType": 0,
      "ModuleType": 2,
      "Enabled": true,
      "Links": "../../../../assets/images/bg-images/old/bg4.jpg",
      "Classes": null,
      "Longitude": null,
      "Latitude": null,
      "StatTranslate": null,
      "FontSz": null,
      "_CreationDate": null,
      "_UpdatedDate": null,
      "_SysNumber": 286331154
    },
    {
      "SkyAccessDesignID": 36,
      "ID": "ColorHeadg",
      "StaticTxt": "Title Color:",
      "VarTxt": null,
      "Color": "#ffffff",
      "BgColor": null,
      "PageType": 8,
      "EntryType": 1,
      "ModuleType": 2,
      "Enabled": true,
      "Links": null,
      "Classes": null,
      "Longitude": null,
      "Latitude": null,
      "StatTranslate": null,
      "FontSz": null,
      "_CreationDate": null,
      "_UpdatedDate": null,
      "_SysNumber": 286331154
    },
    {
      "SkyAccessDesignID": 37,
      "ID": "BgColorHeadg",
      "StaticTxt": "Background color:",
      "VarTxt": null,
      "Color": null,
      "BgColor": "rgb(0,0,0,1)",
      "PageType": 8,
      "EntryType": 2,
      "ModuleType": 2,
      "Enabled": true,
      "Links": null,
      "Classes": null,
      "Longitude": null,
      "Latitude": null,
      "StatTranslate": null,
      "FontSz": null,
      "_CreationDate": null,
      "_UpdatedDate": null,
      "_SysNumber": 286331154
    },
    {
      "SkyAccessDesignID": 38,
      "ID": "WelTxt",
      "StaticTxt": "Welcome Text 1:",
      "VarTxt": "WELCOME",
      "Color": "#ffffff",
      "BgColor": null,
      "PageType": 0,
      "EntryType": 0,
      "ModuleType": 1,
      "Enabled": true,
      "Links": null,
      "Classes": null,
      "Longitude": null,
      "Latitude": null,
      "StatTranslate": null,
      "FontSz": null,
      "_CreationDate": null,
      "_UpdatedDate": null,
      "_SysNumber": 286331154
    },
    {
      "SkyAccessDesignID": 39,
      "ID": "SubTxt",
      "StaticTxt": "Welcome Text 2:",
      "VarTxt": "To the Hotel Sample",
      "Color": "#ffffff",
      "BgColor": null,
      "PageType": 0,
      "EntryType": 0,
      "ModuleType": 1,
      "Enabled": true,
      "Links": null,
      "Classes": null,
      "Longitude": null,
      "Latitude": null,
      "StatTranslate": null,
      "FontSz": null,
      "_CreationDate": null,
      "_UpdatedDate": null,
      "_SysNumber": 286331154
    },
    {
      "SkyAccessDesignID": 40,
      "ID": "BtTxt",
      "StaticTxt": "Button Text:",
      "VarTxt": "DISCOVER THE HOTEL",
      "Color": "#ffffff",
      "BgColor": null,
      "PageType": 0,
      "EntryType": 0,
      "ModuleType": 1,
      "Enabled": true,
      "Links": null,
      "Classes": null,
      "Longitude": null,
      "Latitude": null,
      "StatTranslate": null,
      "FontSz": null,
      "_CreationDate": null,
      "_UpdatedDate": null,
      "_SysNumber": 286331154
    },
    {
      "SkyAccessDesignID": 41,
      "ID": "InfoTxt",
      "StaticTxt": "Info Text:",
      "VarTxt": "Use the chat to book a room , a table and more...",
      "Color": "#ffffff",
      "BgColor": null,
      "PageType": 0,
      "EntryType": 0,
      "ModuleType": 1,
      "Enabled": true,
      "Links": null,
      "Classes": null,
      "Longitude": null,
      "Latitude": null,
      "StatTranslate": null,
      "FontSz": null,
      "_CreationDate": null,
      "_UpdatedDate": null,
      "_SysNumber": 286331154
    },
    {
      "SkyAccessDesignID": 42,
      "ID": "BgColor",
      "StaticTxt": "Background color/opacity:",
      "VarTxt": "",
      "Color": null,
      "BgColor": "rgb(0,0,0,0.5)",
      "PageType": 0,
      "EntryType": 2,
      "ModuleType": 1,
      "Enabled": true,
      "Links": null,
      "Classes": null,
      "Longitude": null,
      "Latitude": null,
      "StatTranslate": null,
      "FontSz": null,
      "_CreationDate": null,
      "_UpdatedDate": null,
      "_SysNumber": 286331154
    },
    {
      "SkyAccessDesignID": 43,
      "ID": "WelTxt2",
      "StaticTxt": "Guide Text 1:",
      "VarTxt": "EXPLORE THE NEIGHBORHOOD",
      "Color": "#ffffff",
      "BgColor": null,
      "PageType": 0,
      "EntryType": 0,
      "ModuleType": 2,
      "Enabled": true,
      "Links": null,
      "Classes": null,
      "Longitude": null,
      "Latitude": null,
      "StatTranslate": null,
      "FontSz": null,
      "_CreationDate": null,
      "_UpdatedDate": null,
      "_SysNumber": 286331154
    },
    {
      "SkyAccessDesignID": 44,
      "ID": "SubTxt2",
      "StaticTxt": "Guide Text 2:",
      "VarTxt": "Our guide provide the best tips and locations in the city, enjoy!",
      "Color": "#ffffff",
      "BgColor": null,
      "PageType": 0,
      "EntryType": 0,
      "ModuleType": 2,
      "Enabled": true,
      "Links": null,
      "Classes": null,
      "Longitude": null,
      "Latitude": null,
      "StatTranslate": null,
      "FontSz": null,
      "_CreationDate": null,
      "_UpdatedDate": null,
      "_SysNumber": 286331154
    },
    {
      "SkyAccessDesignID": 45,
      "ID": "BtTxt2",
      "StaticTxt": "Button Text:",
      "VarTxt": "CITY GUIDE",
      "Color": "#ffffff",
      "BgColor": null,
      "PageType": 0,
      "EntryType": 0,
      "ModuleType": 2,
      "Enabled": true,
      "Links": null,
      "Classes": null,
      "Longitude": null,
      "Latitude": null,
      "StatTranslate": null,
      "FontSz": null,
      "_CreationDate": null,
      "_UpdatedDate": null,
      "_SysNumber": 286331154
    },
    {
      "SkyAccessDesignID": 46,
      "ID": "InfoTxt2",
      "StaticTxt": "Info Text:",
      "VarTxt": "Use the chat to book a room , a table and more...",
      "Color": "#ffffff",
      "BgColor": null,
      "PageType": 0,
      "EntryType": 0,
      "ModuleType": 2,
      "Enabled": true,
      "Links": null,
      "Classes": null,
      "Longitude": null,
      "Latitude": null,
      "StatTranslate": null,
      "FontSz": null,
      "_CreationDate": null,
      "_UpdatedDate": null,
      "_SysNumber": 286331154
    },
    {
      "SkyAccessDesignID": 47,
      "ID": "BgColor2",
      "StaticTxt": "Background color/opacity:",
      "VarTxt": "",
      "Color": null,
      "BgColor": "rgb(0,0,0,0.5)",
      "PageType": 0,
      "EntryType": 2,
      "ModuleType": 2,
      "Enabled": true,
      "Links": null,
      "Classes": null,
      "Longitude": null,
      "Latitude": null,
      "StatTranslate": null,
      "FontSz": null,
      "_CreationDate": null,
      "_UpdatedDate": null,
      "_SysNumber": 286331154
    },
    {
      "SkyAccessDesignID": 48,
      "ID": "HGeo",
      "StaticTxt": "Hotel location:",
      "VarTxt": null,
      "Color": null,
      "BgColor": null,
      "PageType": 0,
      "EntryType": 3,
      "ModuleType": 6,
      "Enabled": true,
      "Links": null,
      "Classes": null,
      "Longitude": "16.2289951",
      "Latitude": "48.0079515",
      "StatTranslate": null,
      "FontSz": null,
      "_CreationDate": null,
      "_UpdatedDate": null,
      "_SysNumber": 286331154
    },
    {
      "SkyAccessDesignID": 49,
      "ID": "GuideGeo1",
      "StaticTxt": "Guide location1:",
      "VarTxt": null,
      "Color": null,
      "BgColor": null,
      "PageType": 0,
      "EntryType": 3,
      "ModuleType": 7,
      "Enabled": true,
      "Links": null,
      "Classes": null,
      "Longitude": "16.3719458",
      "Latitude": "48.2020904",
      "StatTranslate": null,
      "FontSz": null,
      "_CreationDate": null,
      "_UpdatedDate": null,
      "_SysNumber": 286331154
    },
    {
      "SkyAccessDesignID": 50,
      "ID": "GuideGeo2",
      "StaticTxt": "Guide location2:",
      "VarTxt": null,
      "Color": null,
      "BgColor": null,
      "PageType": 0,
      "EntryType": 3,
      "ModuleType": 7,
      "Enabled": true,
      "Links": null,
      "Classes": null,
      "Longitude": "16.3387373",
      "Latitude": "48.1996898",
      "StatTranslate": null,
      "FontSz": null,
      "_CreationDate": null,
      "_UpdatedDate": null,
      "_SysNumber": 286331154
    },
    {
      "SkyAccessDesignID": 51,
      "ID": "business-module-1000",
      "StaticTxt": "Select module:",
      "VarTxt": "In House",
      "Color": null,
      "BgColor": null,
      "PageType": 2,
      "EntryType": 0,
      "ModuleType": 8,
      "Enabled": true,
      "Links": null,
      "Classes": null,
      "Longitude": null,
      "Latitude": null,
      "StatTranslate": null,
      "FontSz": null,
      "_CreationDate": null,
      "_UpdatedDate": null,
      "_SysNumber": 286331154
    },
    {
      "SkyAccessDesignID": 52,
      "ID": "Title",
      "StaticTxt": "Title:",
      "VarTxt": "Rooms & Suites",
      "Color": "#ffffff\"",
      "BgColor": "rgb(0,0,0,0.5)",
      "PageType": 2,
      "EntryType": 4,
      "ModuleType": 8,
      "Enabled": true,
      "Links": null,
      "Classes": null,
      "Longitude": null,
      "Latitude": null,
      "StatTranslate": null,
      "FontSz": null,
      "_CreationDate": null,
      "_UpdatedDate": null,
      "_SysNumber": 286331154
    },
    {
      "SkyAccessDesignID": 53,
      "ID": "Img",
      "StaticTxt": "Image:",
      "VarTxt": null,
      "Color": null,
      "BgColor": null,
      "PageType": 2,
      "EntryType": 0,
      "ModuleType": 8,
      "Enabled": true,
      "Links": "../../../../assets/images/bg-images/old/bg3.jpg",
      "Classes": null,
      "Longitude": null,
      "Latitude": null,
      "StatTranslate": null,
      "FontSz": null,
      "_CreationDate": null,
      "_UpdatedDate": null,
      "_SysNumber": 286331154
    },
    {
      "SkyAccessDesignID": 54,
      "ID": "BtTxt",
      "StaticTxt": "Button text:",
      "VarTxt": "BOOK NOW",
      "Color": "#ffffff",
      "BgColor": null,
      "PageType": 2,
      "EntryType": 0,
      "ModuleType": 8,
      "Enabled": true,
      "Links": null,
      "Classes": null,
      "Longitude": null,
      "Latitude": null,
      "StatTranslate": null,
      "FontSz": null,
      "_CreationDate": null,
      "_UpdatedDate": null,
      "_SysNumber": 286331154
    },
    {
      "SkyAccessDesignID": 55,
      "ID": "ExterLink",
      "StaticTxt": "Set button link:",
      "VarTxt": null,
      "Color": null,
      "BgColor": null,
      "PageType": 2,
      "EntryType": 0,
      "ModuleType": 8,
      "Enabled": true,
      "Links": "http://www.amadeosystems.com",
      "Classes": null,
      "Longitude": null,
      "Latitude": null,
      "StatTranslate": null,
      "FontSz": null,
      "_CreationDate": null,
      "_UpdatedDate": null,
      "_SysNumber": 286331154
    },
    {
      "SkyAccessDesignID": 56,
      "ID": "Descp",
      "StaticTxt": "Details:",
      "VarTxt": "<p>this</p>",
      "Color": null,
      "BgColor": null,
      "PageType": 2,
      "EntryType": 0,
      "ModuleType": 8,
      "Enabled": true,
      "Links": null,
      "Classes": null,
      "Longitude": null,
      "Latitude": null,
      "StatTranslate": null,
      "FontSz": null,
      "_CreationDate": null,
      "_UpdatedDate": null,
      "_SysNumber": 286331154
    },
    {
      "SkyAccessDesignID": 57,
      "ID": "Title",
      "StaticTxt": "Title:",
      "VarTxt": "Rooms & Suites2",
      "Color": "#ffffff\"",
      "BgColor": "rgb(0,0,0,0.5)",
      "PageType": 2,
      "EntryType": 4,
      "ModuleType": 8,
      "Enabled": true,
      "Links": null,
      "Classes": null,
      "Longitude": null,
      "Latitude": null,
      "StatTranslate": null,
      "FontSz": null,
      "_CreationDate": null,
      "_UpdatedDate": null,
      "_SysNumber": 286331154
    },
    {
      "SkyAccessDesignID": 58,
      "ID": "Img",
      "StaticTxt": "Image:",
      "VarTxt": null,
      "Color": null,
      "BgColor": null,
      "PageType": 2,
      "EntryType": 0,
      "ModuleType": 8,
      "Enabled": true,
      "Links": "../../../../assets/images/bg-images/old/bg1.jpg",
      "Classes": null,
      "Longitude": null,
      "Latitude": null,
      "StatTranslate": null,
      "FontSz": null,
      "_CreationDate": null,
      "_UpdatedDate": null,
      "_SysNumber": 286331154
    },
    {
      "SkyAccessDesignID": 59,
      "ID": "BtTxt",
      "StaticTxt": "Button text:",
      "VarTxt": "BOOK NOW",
      "Color": "#ffffff",
      "BgColor": null,
      "PageType": 2,
      "EntryType": 0,
      "ModuleType": 8,
      "Enabled": true,
      "Links": null,
      "Classes": null,
      "Longitude": null,
      "Latitude": null,
      "StatTranslate": null,
      "FontSz": null,
      "_CreationDate": null,
      "_UpdatedDate": null,
      "_SysNumber": 286331154
    },
    {
      "SkyAccessDesignID": 60,
      "ID": "ExterLink",
      "StaticTxt": "Set button link:",
      "VarTxt": null,
      "Color": null,
      "BgColor": null,
      "PageType": 2,
      "EntryType": 0,
      "ModuleType": 8,
      "Enabled": true,
      "Links": "http://www.amadeosystems.com",
      "Classes": null,
      "Longitude": null,
      "Latitude": null,
      "StatTranslate": null,
      "FontSz": null,
      "_CreationDate": null,
      "_UpdatedDate": null,
      "_SysNumber": 286331154
    },
    {
      "SkyAccessDesignID": 61,
      "ID": "Descp",
      "StaticTxt": "Details:",
      "VarTxt": "<p>Add some formatted description here if you want the vertical template to be displayed, or delete it if you don't need the template</p>",
      "Color": null,
      "BgColor": null,
      "PageType": 2,
      "EntryType": 0,
      "ModuleType": 8,
      "Enabled": true,
      "Links": null,
      "Classes": null,
      "Longitude": null,
      "Latitude": null,
      "StatTranslate": null,
      "FontSz": null,
      "_CreationDate": null,
      "_UpdatedDate": null,
      "_SysNumber": 286331154
    },
    {
      "SkyAccessDesignID": 62,
      "ID": "guide-module-1000",
      "StaticTxt": "Select guide:",
      "VarTxt": "Shopping",
      "Color": null,
      "BgColor": null,
      "PageType": 2,
      "EntryType": 0,
      "ModuleType": 9,
      "Enabled": true,
      "Links": null,
      "Classes": null,
      "Longitude": null,
      "Latitude": null,
      "StatTranslate": null,
      "FontSz": null,
      "_CreationDate": null,
      "_UpdatedDate": null,
      "_SysNumber": 286331154
    },
    {
      "SkyAccessDesignID": 63,
      "ID": "GuideGeo2",
      "StaticTxt": "Guide location:",
      "VarTxt": null,
      "Color": null,
      "BgColor": null,
      "PageType": 0,
      "EntryType": 3,
      "ModuleType": 9,
      "Enabled": true,
      "Links": null,
      "Classes": null,
      "Longitude": "16.3387373",
      "Latitude": "48.1996898",
      "StatTranslate": null,
      "FontSz": null,
      "_CreationDate": null,
      "_UpdatedDate": null,
      "_SysNumber": 286331154
    },
    {
      "SkyAccessDesignID": 64,
      "ID": "Title",
      "StaticTxt": "Title:",
      "VarTxt": "Marchandises",
      "Color": "#ffffff\"",
      "BgColor": "rgb(0,0,0,0.5)",
      "PageType": 2,
      "EntryType": 4,
      "ModuleType": 9,
      "Enabled": true,
      "Links": null,
      "Classes": null,
      "Longitude": null,
      "Latitude": null,
      "StatTranslate": null,
      "FontSz": null,
      "_CreationDate": null,
      "_UpdatedDate": null,
      "_SysNumber": 286331154
    },
    {
      "SkyAccessDesignID": 65,
      "ID": "Img",
      "StaticTxt": "Image:",
      "VarTxt": null,
      "Color": null,
      "BgColor": null,
      "PageType": 2,
      "EntryType": 0,
      "ModuleType": 9,
      "Enabled": true,
      "Links": "../../../../assets/images/bg-images/old/bg3.jpg",
      "Classes": null,
      "Longitude": null,
      "Latitude": null,
      "StatTranslate": null,
      "FontSz": null,
      "_CreationDate": null,
      "_UpdatedDate": null,
      "_SysNumber": 286331154
    },
    {
      "SkyAccessDesignID": 66,
      "ID": "BtTxt",
      "StaticTxt": "Button text:",
      "VarTxt": "VISIT US",
      "Color": "#ffffff",
      "BgColor": null,
      "PageType": 2,
      "EntryType": 0,
      "ModuleType": 9,
      "Enabled": true,
      "Links": null,
      "Classes": null,
      "Longitude": null,
      "Latitude": null,
      "StatTranslate": null,
      "FontSz": null,
      "_CreationDate": null,
      "_UpdatedDate": null,
      "_SysNumber": 286331154
    },
    {
      "SkyAccessDesignID": 67,
      "ID": "ExterLink",
      "StaticTxt": "Set button link:",
      "VarTxt": null,
      "Color": null,
      "BgColor": null,
      "PageType": 2,
      "EntryType": 0,
      "ModuleType": 9,
      "Enabled": true,
      "Links": "http://www.amadeosystems.com",
      "Classes": null,
      "Longitude": null,
      "Latitude": null,
      "StatTranslate": null,
      "FontSz": null,
      "_CreationDate": null,
      "_UpdatedDate": null,
      "_SysNumber": 286331154
    },
    {
      "SkyAccessDesignID": 68,
      "ID": "Descp",
      "StaticTxt": "Details:",
      "VarTxt": "<p>this</p>",
      "Color": null,
      "BgColor": null,
      "PageType": 2,
      "EntryType": 0,
      "ModuleType": 9,
      "Enabled": true,
      "Links": null,
      "Classes": null,
      "Longitude": null,
      "Latitude": null,
      "StatTranslate": null,
      "FontSz": null,
      "_CreationDate": null,
      "_UpdatedDate": null,
      "_SysNumber": 286331154
    },
    {
      "SkyAccessDesignID": 69,
      "ID": "GuideGeo2",
      "StaticTxt": "Guide location:",
      "VarTxt": null,
      "Color": null,
      "BgColor": null,
      "PageType": 0,
      "EntryType": 3,
      "ModuleType": 9,
      "Enabled": true,
      "Links": null,
      "Classes": null,
      "Longitude": "16.3719458",
      "Latitude": "48.2020904",
      "StatTranslate": null,
      "FontSz": null,
      "_CreationDate": null,
      "_UpdatedDate": null,
      "_SysNumber": 286331154
    },
    {
      "SkyAccessDesignID": 70,
      "ID": "Title",
      "StaticTxt": "Title:",
      "VarTxt": "Marchandises2",
      "Color": "#ffffff\"",
      "BgColor": "rgb(0,0,0,0.5)",
      "PageType": 2,
      "EntryType": 4,
      "ModuleType": 9,
      "Enabled": true,
      "Links": null,
      "Classes": null,
      "Longitude": null,
      "Latitude": null,
      "StatTranslate": null,
      "FontSz": null,
      "_CreationDate": null,
      "_UpdatedDate": null,
      "_SysNumber": 286331154
    },
    {
      "SkyAccessDesignID": 71,
      "ID": "Img",
      "StaticTxt": "Image:",
      "VarTxt": null,
      "Color": null,
      "BgColor": null,
      "PageType": 2,
      "EntryType": 0,
      "ModuleType": 9,
      "Enabled": true,
      "Links": "../../../../assets/images/bg-images/old/bg1.jpg",
      "Classes": null,
      "Longitude": null,
      "Latitude": null,
      "StatTranslate": null,
      "FontSz": null,
      "_CreationDate": null,
      "_UpdatedDate": null,
      "_SysNumber": 286331154
    },
    {
      "SkyAccessDesignID": 72,
      "ID": "BtTxt",
      "StaticTxt": "Button text:",
      "VarTxt": "VISIT US",
      "Color": "#ffffff",
      "BgColor": null,
      "PageType": 2,
      "EntryType": 0,
      "ModuleType": 9,
      "Enabled": true,
      "Links": null,
      "Classes": null,
      "Longitude": null,
      "Latitude": null,
      "StatTranslate": null,
      "FontSz": null,
      "_CreationDate": null,
      "_UpdatedDate": null,
      "_SysNumber": 286331154
    },
    {
      "SkyAccessDesignID": 73,
      "ID": "ExterLink",
      "StaticTxt": "Set button link:",
      "VarTxt": null,
      "Color": null,
      "BgColor": null,
      "PageType": 2,
      "EntryType": 0,
      "ModuleType": 9,
      "Enabled": true,
      "Links": "http://www.amadeosystems.com",
      "Classes": null,
      "Longitude": null,
      "Latitude": null,
      "StatTranslate": null,
      "FontSz": null,
      "_CreationDate": null,
      "_UpdatedDate": null,
      "_SysNumber": 286331154
    },
    {
      "SkyAccessDesignID": 74,
      "ID": "Descp",
      "StaticTxt": "Details:",
      "VarTxt": "<p>this</p>",
      "Color": null,
      "BgColor": null,
      "PageType": 2,
      "EntryType": 0,
      "ModuleType": 9,
      "Enabled": true,
      "Links": null,
      "Classes": null,
      "Longitude": null,
      "Latitude": null,
      "StatTranslate": null,
      "FontSz": null,
      "_CreationDate": null,
      "_UpdatedDate": null,
      "_SysNumber": 286331154
    },
    {
      "SkyAccessDesignID": 75,
      "ID": "OpColBg",
      "StaticTxt": "Choose the operator color and background:",
      "VarTxt": null,
      "Color": "#ffffff",
      "BgColor": "#000000",
      "PageType": 3,
      "EntryType": 1,
      "ModuleType": 0,
      "Enabled": true,
      "Links": null,
      "Classes": null,
      "Longitude": null,
      "Latitude": null,
      "StatTranslate": null,
      "FontSz": null,
      "_CreationDate": null,
      "_UpdatedDate": null,
      "_SysNumber": 286331154
    },
    {
      "SkyAccessDesignID": 76,
      "ID": "GuestColBg",
      "StaticTxt": "Choose the Guest color and background:",
      "VarTxt": null,
      "Color": "#ffffff",
      "BgColor": "#da0000",
      "PageType": 3,
      "EntryType": 1,
      "ModuleType": 0,
      "Enabled": true,
      "Links": null,
      "Classes": null,
      "Longitude": null,
      "Latitude": null,
      "StatTranslate": null,
      "FontSz": null,
      "_CreationDate": null,
      "_UpdatedDate": null,
      "_SysNumber": 286331154
    },
    {
      "SkyAccessDesignID": 77,
      "ID": "BtColBg",
      "StaticTxt": "Choose the button color and background:",
      "VarTxt": null,
      "Color": "#ffffff",
      "BgColor": "#00fd00",
      "PageType": 3,
      "EntryType": 1,
      "ModuleType": 0,
      "Enabled": true,
      "Links": null,
      "Classes": null,
      "Longitude": null,
      "Latitude": null,
      "StatTranslate": null,
      "FontSz": null,
      "_CreationDate": null,
      "_UpdatedDate": null,
      "_SysNumber": 286331154
    },
    {
      "SkyAccessDesignID": 78,
      "ID": "EnableDescrip",
      "StaticTxt": "Enable / disable the room guide description :",
      "VarTxt": null,
      "Color": "#ffffff",
      "BgColor": "#000000",
      "PageType": 4,
      "EntryType": 0,
      "ModuleType": 0,
      "Enabled": true,
      "Links": null,
      "Classes": null,
      "Longitude": null,
      "Latitude": null,
      "StatTranslate": null,
      "FontSz": null,
      "_CreationDate": null,
      "_UpdatedDate": null,
      "_SysNumber": 286331154
    },
    {
      "SkyAccessDesignID": 79,
      "ID": "EnableArrow",
      "StaticTxt": "Enable / disable navigation arrows :",
      "VarTxt": null,
      "Color": "#ffffff",
      "BgColor": "#000000",
      "PageType": 4,
      "EntryType": 0,
      "ModuleType": 0,
      "Enabled": true,
      "Links": null,
      "Classes": null,
      "Longitude": null,
      "Latitude": null,
      "StatTranslate": null,
      "FontSz": null,
      "_CreationDate": null,
      "_UpdatedDate": null,
      "_SysNumber": 286331154
    },
    {
      "SkyAccessDesignID": 80,
      "ID": "EnablePaging",
      "StaticTxt": "Enable / disable Pagination :",
      "VarTxt": null,
      "Color": "#ffffff",
      "BgColor": "#000000",
      "PageType": 4,
      "EntryType": 0,
      "ModuleType": 0,
      "Enabled": true,
      "Links": null,
      "Classes": null,
      "Longitude": null,
      "Latitude": null,
      "StatTranslate": null,
      "FontSz": null,
      "_CreationDate": null,
      "_UpdatedDate": null,
      "_SysNumber": 286331154
    }
  ];


  public static _ConfigPage: IConfigPage =
    {
      Header:
        [
          { Enabled: true, ID: "HeaderColor", StaticTxt: "Header Color", EntryType: EntryTypes.Color, Color: "#ffffff", ModuleType: ModuleTypes.Header, PageType: PageTypes.SA_ConfigView },
          { Enabled: true, ID: "HeaderBgColor", StaticTxt: "Header background Color and Opacity", EntryType: EntryTypes.BgColor, BgColor: "rgb(0,40,0,0.5)", ModuleType: ModuleTypes.Header, PageType: PageTypes.SA_ConfigView },
          { Enabled: true, ID: "HeaderIcon", StaticTxt: "Header Icon 20x144px", EntryType: EntryTypes.Txt, ModuleType: ModuleTypes.Header, PageType: PageTypes.SA_ConfigView },
          { Enabled: true, ID: "ShowHeaderIcon", StaticTxt: "Show header icon", EntryType: EntryTypes.Txt, ModuleType: ModuleTypes.Header, PageType: PageTypes.SA_ConfigView },
          { Enabled: true, ID: "HeaderTitle", StaticTxt: "Modify header title :", VarTxt: ".SKYACCESS.", EntryType: EntryTypes.Txt, ModuleType: ModuleTypes.Header, PageType: PageTypes.SA_ConfigView },
          { ID: "HeaderFixed", StaticTxt: "Header fixed : ", EntryType: EntryTypes.Txt, Enabled: true, ModuleType: ModuleTypes.Header, PageType: PageTypes.SA_ConfigView }
        ],
      MainNenu:
        [
          { Enabled: true, ID: "MainMenuColor", StaticTxt: "Main menu Color", EntryType: EntryTypes.Color, Color: "#ffffff", ModuleType: ModuleTypes.MainNenu, PageType: PageTypes.SA_ConfigView },
          { Enabled: true, ID: "MainMenuBgColor", StaticTxt: "Main menu background Color and Opacity", EntryType: EntryTypes.BgColor, BgColor: "rgb(0,20,40,0.5)", ModuleType: ModuleTypes.MainNenu, PageType: PageTypes.SA_ConfigView },
          { Enabled: true, ID: "BgImage", StaticTxt: "Main menu background image 20x200px", EntryType: EntryTypes.Txt, ModuleType: ModuleTypes.MainNenu, PageType: PageTypes.SA_ConfigView },
          { Enabled: true, ID: "MmFixed", StaticTxt: "Main menu fixed : ", EntryType: EntryTypes.Txt, ModuleType: ModuleTypes.MainNenu, PageType: PageTypes.SA_ConfigView }
        ],
      KeyMenu:
        [
          { Enabled: true, ID: "KmColor", StaticTxt: "Key menu Color", EntryType: EntryTypes.Color, Color: "#ffffff", ModuleType: ModuleTypes.KeyMenu, PageType: PageTypes.SA_ConfigView },
          { Enabled: true, ID: "KmBgColor", StaticTxt: "Header background Color and Opacity", EntryType: EntryTypes.BgColor, BgColor: "rgb(0,40,0,1)", ModuleType: ModuleTypes.KeyMenu, PageType: PageTypes.SA_ConfigView }
        ]

    };

  public static _GnSetting: IItem[] =
    [
      { ID: "MmMuliprop", StaticTxt: "Multi-Properties:", VarTxt: "Multi-Properties", EntryType: EntryTypes.Txt, Enabled: false, Classes: "feather icon-cloud", ModuleType: ModuleTypes.NotAModule, PageType: PageTypes.SA_GenSetting },
      { ID: "MmHome", StaticTxt: "Home :", VarTxt: "Home", EntryType: EntryTypes.Txt, Enabled: true, Classes: "feather icon-home", ModuleType: ModuleTypes.NotAModule, PageType: PageTypes.SA_GenSetting },
      { ID: "MmHotel", StaticTxt: "Hotel :", VarTxt: "Hotel", EntryType: EntryTypes.Txt, Enabled: true, Classes: "fa fa-building", ModuleType: ModuleTypes.NotAModule, PageType: PageTypes.SA_GenSetting },
      { ID: "MmGuide", StaticTxt: "City Guide :", VarTxt: "City Guide", EntryType: EntryTypes.Txt, Enabled: false, Classes: "fa fa-city", ModuleType: ModuleTypes.NotAModule, PageType: PageTypes.SA_GenSetting },
      { ID: "ShareOnFb", StaticTxt: "Share on facebook :", Links: "https://www.facebook.com/amadeosystems", VarTxt: "Facebook", EntryType: EntryTypes.Txt, Enabled: false, Classes: "fab fa-facebook", ModuleType: ModuleTypes.NotAModule, PageType: PageTypes.SA_GenSetting }, //Classes:"fab fa-facebook"
      { ID: "ShareOnTTr", StaticTxt: "follow on twitter :", Links: "https://twitter.com/amadeosystems/", VarTxt: "Twitter", EntryType: EntryTypes.Txt, Enabled: false, Classes: "fab fa-twitter", ModuleType: ModuleTypes.NotAModule, PageType: PageTypes.SA_GenSetting }, //Classes:"fab fa-facebook"
      { ID: "ShareOnInst", StaticTxt: "Share on instagram :", Links: "https://www.amadeosystems.com/", VarTxt: "instagram", EntryType: EntryTypes.Txt, Enabled: false, Classes: "feather icon-instagram", ModuleType: ModuleTypes.NotAModule, PageType: PageTypes.SA_GenSetting },
      { ID: "HomeScreen", StaticTxt: "Allow the user to add the app to the home screen : ", VarTxt: null, EntryType: EntryTypes.Txt, Enabled: false, Classes: "fas fa-home", ModuleType: ModuleTypes.NotAModule, PageType: PageTypes.SA_GenSetting },

    ];

  public static _ModuleList: IItem[] = [
    { ID: "business-module-1000", StaticTxt: "Module 1:", VarTxt: "In House", Enabled: false, Links: '../../../../assets/images/bg-images/defaults/hotel/in-house/bg1.jpg', EntryType: EntryTypes.Txt, ModuleType: ModuleTypes.IsHotel, PageType: PageTypes.SA_ModuleSetting },
    { ID: "business-module-10000", StaticTxt: "Module 2:", VarTxt: "Rooms & Suites", Enabled: false, Links: '../../../../assets/images/bg-images/defaults/hotel/room-and-suites/bg1.jpg', EntryType: EntryTypes.Txt, ModuleType: ModuleTypes.IsHotel, PageType: PageTypes.SA_ModuleSetting },
    { ID: "business-module-100000", StaticTxt: "Module 3:", VarTxt: "Restaurant", Enabled: false, Links: '../../../../assets/images/bg-images/defaults/hotel/restaurant/bg1.jpg', EntryType: EntryTypes.Txt, ModuleType: ModuleTypes.IsHotel, PageType: PageTypes.SA_ModuleSetting },
    { ID: "business-module-2000", StaticTxt: "Module 4:", VarTxt: "Room Services", Enabled: false, Links: '../../../../assets/images/bg-images/defaults/hotel/room-services/bg1.jpg', EntryType: EntryTypes.Txt, ModuleType: ModuleTypes.IsHotel, PageType: PageTypes.SA_ModuleSetting },
    { ID: "business-module-20000", StaticTxt: "Module 5:", VarTxt: "BAR", Enabled: false, Links: '../../../../assets/images/bg-images/defaults/hotel/bar/bg1.jpg', EntryType: EntryTypes.Txt, ModuleType: ModuleTypes.IsHotel, PageType: PageTypes.SA_ModuleSetting },
    { ID: "business-module-200000", StaticTxt: "Module 6:", VarTxt: "Fitness", Enabled: false, Links: '../../../../assets/images/bg-images/defaults/hotel/fitness/bg1.jpg', EntryType: EntryTypes.Txt, ModuleType: ModuleTypes.IsHotel, PageType: PageTypes.SA_ModuleSetting },
    { ID: "business-module-20000000", StaticTxt: "Module 7:", VarTxt: "SPA", Enabled: false, Links: '../../../../assets/images/bg-images/defaults/hotel/spa/bg1.jpg', EntryType: EntryTypes.Txt, ModuleType: ModuleTypes.IsHotel, PageType: PageTypes.SA_ModuleSetting },
    { ID: "ColorHead", VarTxt: "Title Color:", Enabled: true, EntryType: EntryTypes.Color, Color: "#ffffff", BgColor: null, ModuleType: ModuleTypes.IsHotel, PageType: PageTypes.SA_ModuleSetting },
    { ID: "BgColorHead", VarTxt: "Background color:", Enabled: true, EntryType: EntryTypes.BgColor, Color: null, BgColor: "rgb(0,0,0,1)", ModuleType: ModuleTypes.IsHotel, PageType: PageTypes.SA_ModuleSetting },
    { ID: "SlideSett", VarTxt: "Animation settings:", Enabled: true, EntryType: EntryTypes.SlideSett, _Speed: 50, _Eff: 'default', ModuleType: ModuleTypes.IsHotel, PageType: PageTypes.SA_ModuleSetting },

  ];

  public static _ModuleList2: IItem[] = [
    { ID: "guide-module-1000", StaticTxt: "Guide 1:", VarTxt: "Shopping", Enabled: false, Links: '../../../../assets/images/bg-images/defaults/city-guide/shopping/bg1.jpg', EntryType: EntryTypes.Txt, ModuleType: ModuleTypes.IsGuide, PageType: PageTypes.SA_ModuleSetting },
    { ID: "guide-module-10000", StaticTxt: "Guide 2:", VarTxt: "Restaurants", Enabled: false, Links: '../../../../assets/images/bg-images/defaults/city-guide/restaurants/bg1.jpg', EntryType: EntryTypes.Txt, ModuleType: ModuleTypes.IsGuide, PageType: PageTypes.SA_ModuleSetting },
    { ID: "guide-module-100000", StaticTxt: "Guide 3:", VarTxt: "Night Life", Enabled: false, Links: '../../../../assets/images/bg-images/defaults/city-guide/night-life/bg1.jpg', EntryType: EntryTypes.Txt, ModuleType: ModuleTypes.IsGuide, PageType: PageTypes.SA_ModuleSetting },
    { ID: "guide-module-2000", StaticTxt: "Guide 4:", VarTxt: "Kids Zone", Enabled: false, Links: '../../../../assets/images/bg-images/defaults/city-guide/kids-zone/bg1.jpg', EntryType: EntryTypes.Txt, ModuleType: ModuleTypes.IsGuide, PageType: PageTypes.SA_ModuleSetting },
    { ID: "guide-module-20000", StaticTxt: "Guide 5:", VarTxt: "Neighborhood", Enabled: false, Links: '../../../../assets/images/bg-images/defaults/city-guide/neighborhood/bg1.jpg', EntryType: EntryTypes.Txt, ModuleType: ModuleTypes.IsGuide, PageType: PageTypes.SA_ModuleSetting },
    { ID: "guide-module-200000", StaticTxt: "Guide 6:", VarTxt: "Must Know", Enabled: false, Links: '../../../../assets/images/bg-images/defaults/city-guide/must-know/bg1.jpg', EntryType: EntryTypes.Txt, ModuleType: ModuleTypes.IsGuide, PageType: PageTypes.SA_ModuleSetting },
    { ID: "guide-module-20000000", StaticTxt: "Guide 7:", VarTxt: "Mechandises", Enabled: false, Links: '../../../../assets/images/bg-images/defaults/city-guide/mechandises/bg1.jpg', EntryType: EntryTypes.Txt, ModuleType: ModuleTypes.IsGuide, PageType: PageTypes.SA_ModuleSetting },

    { ID: "ColorHeadg", StaticTxt: null, VarTxt: "Title Color:", Enabled: true, EntryType: EntryTypes.Color, Color: "#ffffff", BgColor: null, ModuleType: ModuleTypes.IsGuide, PageType: PageTypes.SA_ModuleSetting },
    { ID: "BgColorHeadg", StaticTxt: null, VarTxt: "Background color:", Enabled: true, EntryType: EntryTypes.BgColor, Color: null, BgColor: "rgb(0,0,0,1)", ModuleType: ModuleTypes.IsGuide, PageType: PageTypes.SA_ModuleSetting },
    { ID: "SlideSett", VarTxt: "Animation settings:", Enabled: true, EntryType: EntryTypes.SlideSett, _Speed: 50, _Eff: 'default', ModuleType: ModuleTypes.IsGuide, PageType: PageTypes.SA_ModuleSetting },

  ];

  public static _WelcomePages: IWelcomePage =
    {
      Hotel:
        [
          { Enabled: true, ID: "WelTxt", StaticTxt: "Welcome Text 1:", VarTxt: "WELCOME", Color: "#ffffff", EntryType: EntryTypes.Txt, ModuleType: ModuleTypes.IsHotel, PageType: PageTypes.SA_WelcomeView },
          { Enabled: false, ID: "SubTxt", StaticTxt: "Welcome Text 2:", VarTxt: "To the Hotel Sample, Vienna/Austria", Color: "#ffffff", EntryType: EntryTypes.Txt, ModuleType: ModuleTypes.IsHotel, PageType: PageTypes.SA_WelcomeView },
          { Enabled: false, ID: "BtTxt", StaticTxt: "Button Text:", VarTxt: "DISCOVER THE HOTEL", Color: "#ffffff", EntryType: EntryTypes.Txt, ModuleType: ModuleTypes.IsHotel, PageType: PageTypes.SA_WelcomeView },
          { Enabled: false, ID: "InfoTxt", StaticTxt: "Info Text:", VarTxt: "Use the chat to book a room , a table and more...", Color: "#ffffff", EntryType: EntryTypes.Txt, ModuleType: ModuleTypes.IsHotel, PageType: PageTypes.SA_WelcomeView },
          { Enabled: true, ID: "BgColor", StaticTxt: "Background color/opacity:", BgColor: "rgb(0,0,0,0.5)", EntryType: EntryTypes.BgColor, ModuleType: ModuleTypes.IsHotel, PageType: PageTypes.SA_WelcomeView }
        ],
      CityGuide:
        [
          { Enabled: false, ID: "WelTxt2", StaticTxt: "Guide Text 1:", VarTxt: "EXPLORE THE NEIGHBORHOOD", Color: "#ffffff", EntryType: EntryTypes.Txt, ModuleType: ModuleTypes.IsGuide, PageType: PageTypes.SA_WelcomeView },
          { Enabled: false, ID: "SubTxt2", StaticTxt: "Guide Text 2:", VarTxt: "Our guide provide the best tips and locations in the city, enjoy!", Color: "#ffffff", EntryType: EntryTypes.Txt, ModuleType: ModuleTypes.IsGuide, PageType: PageTypes.SA_WelcomeView },
          { Enabled: false, ID: "BtTxt2", StaticTxt: "Button Text:", VarTxt: "CITY GUIDE", Color: "#ffffff", EntryType: EntryTypes.Txt, ModuleType: ModuleTypes.IsGuide, PageType: PageTypes.SA_WelcomeView },
          { Enabled: false, ID: "InfoTxt2", StaticTxt: "Info Text:", VarTxt: "Use the chat to book a room , a table and more...", Color: "#ffffff", EntryType: EntryTypes.Txt, ModuleType: ModuleTypes.IsGuide, PageType: PageTypes.SA_WelcomeView },
          { Enabled: true, ID: "BgColor2", StaticTxt: "Background color/opacity:", BgColor: "rgb(0,0,0,0.5)", EntryType: EntryTypes.BgColor, ModuleType: ModuleTypes.IsGuide, PageType: PageTypes.SA_WelcomeView }
        ],
      HLocation: { Enabled: false, ID: "HGeo", StaticTxt: "Hotel location:", Latitude: "48.0079515", Longitude: "16.2289951", EntryType: EntryTypes.Geo, ModuleType: ModuleTypes.HLocation, PageType: PageTypes.SA_WelcomeView },
      CityLocation:
        [
          { Enabled: false, ID: "GuideGeo1", StaticTxt: "Guide location1:", Latitude: "48.2020904", Longitude: "16.3719458", EntryType: EntryTypes.Geo, ModuleType: ModuleTypes.CityLocation, PageType: PageTypes.SA_WelcomeView },
          { Enabled: false, ID: "GuideGeo2", StaticTxt: "Guide location2:", Latitude: "48.1996898", Longitude: "16.3387373", EntryType: EntryTypes.Geo, ModuleType: ModuleTypes.CityLocation, PageType: PageTypes.SA_WelcomeView },
        ],
      WVideo: { Enabled: true, ID: "Wvid", StaticTxt: "Background video:", Links: "assets/videos/rain.mp4", EntryType: EntryTypes.Txt, ModuleType: ModuleTypes.WVideo, PageType: PageTypes.SA_WelcomeView },
      WBgImg: { Enabled: true, ID: "Wimg", StaticTxt: "Background Image:", Links: "assets/images/ads/education_HR_RGB.jpg", EntryType: EntryTypes.Txt, ModuleType: ModuleTypes.WBgImg, PageType: PageTypes.SA_WelcomeView },
      WGuestData: [
        { Enabled: true, ID: "WGname", StaticTxt: "Guest Name:", VarTxt: "Dear {{Guest}}", Color: "#ffffff", EntryType: EntryTypes.Txt, ModuleType: ModuleTypes.WGData, PageType: PageTypes.SA_WelcomeView },
        { Enabled: true, ID: "WGStay", StaticTxt: "Stay:", VarTxt: "Stay:", EntryType: EntryTypes.Txt, ModuleType: ModuleTypes.WGData, PageType: PageTypes.SA_WelcomeView },
      ]

    };

  public static _Businesses: IBusiness =
    {
      Hotel:
        [
          {
            ItemModule: { Enabled: true, ID: "business-module-1000", StaticTxt: "Select module:", VarTxt: "In House", EntryType: EntryTypes.Txt, ModuleType: ModuleTypes.IsModuleHotel1, PageType: PageTypes.SA_BusinessesView },
            Itemlist: [
              {
                Items: [
                  { _Ord: 0, ID: "Title", StaticTxt: "Title:", VarTxt: "In House 1", Color: "#ffffff", BgColor: "rgb(0,0,0,0.5)", EntryType: EntryTypes.ALL, ModuleType: ModuleTypes.IsModuleHotel1, PageType: PageTypes.SA_BusinessesView },
                  { _Ord: 0, ID: "Img", StaticTxt: "Image:", Links: "../../../../assets/images/bg-images/defaults/hotel/in-house/bg1.jpg", VarTxt: null, EntryType: EntryTypes.Txt, ModuleType: ModuleTypes.IsModuleHotel1, PageType: PageTypes.SA_BusinessesView },
                  { _Ord: 0, ID: "BtTxt", StaticTxt: "Button text:", VarTxt: "BOOK NOW", Color: "#ffffff", EntryType: EntryTypes.Txt, ModuleType: ModuleTypes.IsModuleHotel1, PageType: PageTypes.SA_BusinessesView },
                  { _Ord: 0, ID: "ExterLink", StaticTxt: "Set button link:", Links: "http://www.amadeosystems.com", EntryType: EntryTypes.Txt, ModuleType: ModuleTypes.IsModuleHotel1, PageType: PageTypes.SA_BusinessesView },
                  { _Ord: 0, ID: "Descp", StaticTxt: "Details:", VarTxt: "<p>Add some formatted description here if you want the vertical template to be displayed, or delete it if you don't need the template</p>", Color: null, EntryType: EntryTypes.Txt, ModuleType: ModuleTypes.IsModuleHotel1, PageType: PageTypes.SA_BusinessesView }
                ]
              },
              {
                Items: [
                  { _Ord: 1, ID: "Title", StaticTxt: "Title:", VarTxt: "In House 2", Color: "#ffffff", BgColor: "rgb(0,0,0,0.5)", EntryType: EntryTypes.ALL, ModuleType: ModuleTypes.IsModuleHotel1, PageType: PageTypes.SA_BusinessesView },
                  { _Ord: 1, ID: "Img", StaticTxt: "Image:", Links: "../../../../assets/images/bg-images/defaults/hotel/in-house/bg2.jpg", VarTxt: null, EntryType: EntryTypes.Txt, ModuleType: ModuleTypes.IsModuleHotel1, PageType: PageTypes.SA_BusinessesView },
                  { _Ord: 1, ID: "BtTxt", StaticTxt: "Button text:", VarTxt: "BOOK NOW", Color: "#ffffff", EntryType: EntryTypes.Txt, ModuleType: ModuleTypes.IsModuleHotel1, PageType: PageTypes.SA_BusinessesView },
                  { _Ord: 1, ID: "ExterLink", StaticTxt: "Set button link:", Links: "http://www.amadeosystems.com", EntryType: EntryTypes.Txt, ModuleType: ModuleTypes.IsModuleHotel1, PageType: PageTypes.SA_BusinessesView },
                  { _Ord: 1, ID: "Descp", StaticTxt: "Details:", VarTxt: "<p>Add some formatted description here if you want the vertical template to be displayed, or delete it if you don't need the template</p>", Color: null, EntryType: EntryTypes.Txt, ModuleType: ModuleTypes.IsModuleHotel1, PageType: PageTypes.SA_BusinessesView }
                ]
              },
              {
                Items: [
                  { _Ord: 2, ID: "Title", StaticTxt: "Title:", VarTxt: "In House 3", Color: "#ffffff", BgColor: "rgb(0,0,0,0.5)", EntryType: EntryTypes.ALL, ModuleType: ModuleTypes.IsModuleHotel1, PageType: PageTypes.SA_BusinessesView },
                  { _Ord: 2, ID: "Img", StaticTxt: "Image:", Links: "../../../../assets/images/bg-images/defaults/hotel/in-house/bg3.jpg", VarTxt: null, EntryType: EntryTypes.Txt, ModuleType: ModuleTypes.IsModuleHotel1, PageType: PageTypes.SA_BusinessesView },
                  { _Ord: 2, ID: "BtTxt", StaticTxt: "Button text:", VarTxt: "BOOK NOW", Color: "#ffffff", EntryType: EntryTypes.Txt, ModuleType: ModuleTypes.IsModuleHotel1, PageType: PageTypes.SA_BusinessesView },
                  { _Ord: 2, ID: "ExterLink", StaticTxt: "Set button link:", Links: "http://www.amadeosystems.com", EntryType: EntryTypes.Txt, ModuleType: ModuleTypes.IsModuleHotel1, PageType: PageTypes.SA_BusinessesView },
                  { _Ord: 2, ID: "Descp", StaticTxt: "Details:", VarTxt: "<p>Add some formatted description here if you want the vertical template to be displayed, or delete it if you don't need the template</p>", Color: null, EntryType: EntryTypes.Txt, ModuleType: ModuleTypes.IsModuleHotel1, PageType: PageTypes.SA_BusinessesView }
                ]
              }
            ]
          },
          {
            ItemModule: { ID: "business-module-10000", StaticTxt: "Select module:", VarTxt: "Rooms & Suites", EntryType: EntryTypes.Txt, ModuleType: ModuleTypes.IsModuleHotel2, PageType: PageTypes.SA_BusinessesView },
            Itemlist: [

              {
                Items: [
                  { _Ord: 0, ID: "Title", StaticTxt: "Title:", VarTxt: "Rooms & Suites 1", Color: "#ffffff", BgColor: "rgb(0,0,0,0.5)", EntryType: EntryTypes.ALL, ModuleType: ModuleTypes.IsModuleHotel2, PageType: PageTypes.SA_BusinessesView },
                  { _Ord: 0, ID: "Img", StaticTxt: "Image:", Links: "../../../../assets/images/bg-images/defaults/hotel/room-and-suites/bg1.jpg", VarTxt: null, EntryType: EntryTypes.Txt, ModuleType: ModuleTypes.IsModuleHotel2, PageType: PageTypes.SA_BusinessesView },
                  { _Ord: 0, ID: "BtTxt", StaticTxt: "Button text:", VarTxt: "BOOK NOW", Color: "#ffffff", EntryType: EntryTypes.Txt, ModuleType: ModuleTypes.IsModuleHotel2, PageType: PageTypes.SA_BusinessesView },
                  { _Ord: 0, ID: "ExterLink", StaticTxt: "Set button link:", Links: "http://www.amadeosystems.com", EntryType: EntryTypes.Txt, ModuleType: ModuleTypes.IsModuleHotel2, PageType: PageTypes.SA_BusinessesView },
                  { _Ord: 0, ID: "Descp", StaticTxt: "Details:", VarTxt: "<p>Add some formatted description here if you want the vertical template to be displayed, or delete it if you don't need the template</p>", Color: null, EntryType: EntryTypes.Txt, ModuleType: ModuleTypes.IsModuleHotel2, PageType: PageTypes.SA_BusinessesView }
                ]
              },
              {
                Items: [
                  { _Ord: 1, ID: "Title", StaticTxt: "Title:", VarTxt: "Rooms & Suites 2", Color: "#ffffff", BgColor: "rgb(0,0,0,0.5)", EntryType: EntryTypes.ALL, ModuleType: ModuleTypes.IsModuleHotel2, PageType: PageTypes.SA_BusinessesView },
                  { _Ord: 1, ID: "Img", StaticTxt: "Image:", Links: "../../../../assets/images/bg-images/defaults/hotel/room-and-suites/bg2.jpg", VarTxt: null, EntryType: EntryTypes.Txt, ModuleType: ModuleTypes.IsModuleHotel2, PageType: PageTypes.SA_BusinessesView },
                  { _Ord: 1, ID: "BtTxt", StaticTxt: "Button text:", VarTxt: "BOOK NOW", Color: "#ffffff", EntryType: EntryTypes.Txt, ModuleType: ModuleTypes.IsModuleHotel2, PageType: PageTypes.SA_BusinessesView },
                  { _Ord: 1, ID: "ExterLink", StaticTxt: "Set button link:", Links: "http://www.amadeosystems.com", EntryType: EntryTypes.Txt, ModuleType: ModuleTypes.IsModuleHotel2, PageType: PageTypes.SA_BusinessesView },
                  { _Ord: 1, ID: "Descp", StaticTxt: "Details:", VarTxt: "<p>Add some formatted description here if you want the vertical template to be displayed, or delete it if you don't need the template</p>", Color: null, EntryType: EntryTypes.Txt, ModuleType: ModuleTypes.IsModuleHotel2, PageType: PageTypes.SA_BusinessesView }
                ]
              },
              {
                Items: [
                  { _Ord: 2, ID: "Title", StaticTxt: "Title:", VarTxt: "Rooms & Suites 3", Color: "#ffffff", BgColor: "rgb(0,0,0,0.5)", EntryType: EntryTypes.ALL, ModuleType: ModuleTypes.IsModuleHotel2, PageType: PageTypes.SA_BusinessesView },
                  { _Ord: 2, ID: "Img", StaticTxt: "Image:", Links: "../../../../assets/images/bg-images/defaults/hotel/room-and-suites/bg3.jpg", VarTxt: null, EntryType: EntryTypes.Txt, ModuleType: ModuleTypes.IsModuleHotel2, PageType: PageTypes.SA_BusinessesView },
                  { _Ord: 2, ID: "BtTxt", StaticTxt: "Button text:", VarTxt: "BOOK NOW", Color: "#ffffff", EntryType: EntryTypes.Txt, ModuleType: ModuleTypes.IsModuleHotel2, PageType: PageTypes.SA_BusinessesView },
                  { _Ord: 2, ID: "ExterLink", StaticTxt: "Set button link:", Links: "http://www.amadeosystems.com", EntryType: EntryTypes.Txt, ModuleType: ModuleTypes.IsModuleHotel2, PageType: PageTypes.SA_BusinessesView },
                  { _Ord: 2, ID: "Descp", StaticTxt: "Details:", VarTxt: "<p>Add some formatted description here if you want the vertical template to be displayed, or delete it if you don't need the template</p>", Color: null, EntryType: EntryTypes.Txt, ModuleType: ModuleTypes.IsModuleHotel2, PageType: PageTypes.SA_BusinessesView }
                ]
              }
            ]
          },
          {
            ItemModule: { ID: "business-module-100000", StaticTxt: "Select module:", VarTxt: "Restaurant", EntryType: EntryTypes.Txt, ModuleType: ModuleTypes.IsModuleHotel3, PageType: PageTypes.SA_BusinessesView },
            Itemlist: [
              {
                Items: [
                  { _Ord: 0, ID: "Title", StaticTxt: "Title:", VarTxt: "Restaurant 1", Color: "#ffffff", BgColor: "rgb(0,0,0,0.5)", EntryType: EntryTypes.ALL, ModuleType: ModuleTypes.IsModuleHotel3, PageType: PageTypes.SA_BusinessesView },
                  { _Ord: 0, ID: "Img", StaticTxt: "Image:", Links: "../../../../assets/images/bg-images/defaults/hotel/restaurant/bg1.jpg", VarTxt: null, EntryType: EntryTypes.Txt, ModuleType: ModuleTypes.IsModuleHotel3, PageType: PageTypes.SA_BusinessesView },
                  { _Ord: 0, ID: "BtTxt", StaticTxt: "Button text:", VarTxt: "PLACE AN ORDER", Color: "#ffffff", EntryType: EntryTypes.Txt, ModuleType: ModuleTypes.IsModuleHotel3, PageType: PageTypes.SA_BusinessesView },
                  { _Ord: 0, ID: "ExterLink", StaticTxt: "Set button link:", Links: "http://www.amadeosystems.com", EntryType: EntryTypes.Txt, ModuleType: ModuleTypes.IsModuleHotel3, PageType: PageTypes.SA_BusinessesView },
                  { _Ord: 0, ID: "Descp", StaticTxt: "Details:", VarTxt: "<p>Add some formatted description here if you want the vertical template to be displayed, or delete it if you don't need the template</p>", Color: null, EntryType: EntryTypes.Txt, ModuleType: ModuleTypes.IsModuleHotel3, PageType: PageTypes.SA_BusinessesView }
                ]
              },
              {
                Items: [
                  { _Ord: 1, ID: "Title", StaticTxt: "Title:", VarTxt: "Restaurant 2", Color: "#ffffff", BgColor: "rgb(0,0,0,0.5)", EntryType: EntryTypes.ALL, ModuleType: ModuleTypes.IsModuleHotel3, PageType: PageTypes.SA_BusinessesView },
                  { _Ord: 1, ID: "Img", StaticTxt: "Image:", Links: "../../../../assets/images/bg-images/defaults/hotel/restaurant/bg2.jpg", VarTxt: null, EntryType: EntryTypes.Txt, ModuleType: ModuleTypes.IsModuleHotel3, PageType: PageTypes.SA_BusinessesView },
                  { _Ord: 1, ID: "BtTxt", StaticTxt: "Button text:", VarTxt: "PLACE AN ORDER", Color: "#ffffff", EntryType: EntryTypes.Txt, ModuleType: ModuleTypes.IsModuleHotel3, PageType: PageTypes.SA_BusinessesView },
                  { _Ord: 1, ID: "ExterLink", StaticTxt: "Set button link:", Links: "http://www.amadeosystems.com", EntryType: EntryTypes.Txt, ModuleType: ModuleTypes.IsModuleHotel3, PageType: PageTypes.SA_BusinessesView },
                  { _Ord: 1, ID: "Descp", StaticTxt: "Details:", VarTxt: "<p>Add some formatted description here if you want the vertical template to be displayed, or delete it if you don't need the template</p>", Color: null, EntryType: EntryTypes.Txt, ModuleType: ModuleTypes.IsModuleHotel3, PageType: PageTypes.SA_BusinessesView }
                ]
              },
              {
                Items: [
                  { _Ord: 2, ID: "Title", StaticTxt: "Title:", VarTxt: "Restaurant 3", Color: "#ffffff", BgColor: "rgb(0,0,0,0.5)", EntryType: EntryTypes.ALL, ModuleType: ModuleTypes.IsModuleHotel3, PageType: PageTypes.SA_BusinessesView },
                  { _Ord: 2, ID: "Img", StaticTxt: "Image:", Links: "../../../../assets/images/bg-images/defaults/hotel/restaurant/bg3.jpg", VarTxt: null, EntryType: EntryTypes.Txt, ModuleType: ModuleTypes.IsModuleHotel3, PageType: PageTypes.SA_BusinessesView },
                  { _Ord: 2, ID: "BtTxt", StaticTxt: "Button text:", VarTxt: "PLACE AN ORDER", Color: "#ffffff", EntryType: EntryTypes.Txt, ModuleType: ModuleTypes.IsModuleHotel3, PageType: PageTypes.SA_BusinessesView },
                  { _Ord: 2, ID: "ExterLink", StaticTxt: "Set button link:", Links: "http://www.amadeosystems.com", EntryType: EntryTypes.Txt, ModuleType: ModuleTypes.IsModuleHotel3, PageType: PageTypes.SA_BusinessesView },
                  { _Ord: 2, ID: "Descp", StaticTxt: "Details:", VarTxt: "<p>Add some formatted description here if you want the vertical template to be displayed, or delete it if you don't need the template</p>", Color: null, EntryType: EntryTypes.Txt, ModuleType: ModuleTypes.IsModuleHotel3, PageType: PageTypes.SA_BusinessesView }
                ]
              }
            ]
          },
          {
            ItemModule: { ID: "business-module-2000", StaticTxt: "Select module:", VarTxt: "Room Services", EntryType: EntryTypes.Txt, ModuleType: ModuleTypes.IsModuleHotel4, PageType: PageTypes.SA_BusinessesView },
            Itemlist: [
              {
                Items: [
                  { _Ord: 0, ID: "Title", StaticTxt: "Title:", VarTxt: "Room Services 1", Color: "#ffffff", BgColor: "rgb(0,0,0,0.5)", EntryType: EntryTypes.ALL, ModuleType: ModuleTypes.IsModuleHotel4, PageType: PageTypes.SA_BusinessesView },
                  { _Ord: 0, ID: "Img", StaticTxt: "Image:", Links: "../../../../assets/images/bg-images/defaults/hotel/room-services/bg1.jpg", VarTxt: null, EntryType: EntryTypes.Txt, ModuleType: ModuleTypes.IsModuleHotel4, PageType: PageTypes.SA_BusinessesView },
                  { _Ord: 0, ID: "BtTxt", StaticTxt: "Button text:", VarTxt: "REQUEST SERVICE", Color: "#ffffff", EntryType: EntryTypes.Txt, ModuleType: ModuleTypes.IsModuleHotel4, PageType: PageTypes.SA_BusinessesView },
                  { _Ord: 0, ID: "ExterLink", StaticTxt: "Set button link:", Links: "http://www.amadeosystems.com", EntryType: EntryTypes.Txt, ModuleType: ModuleTypes.IsModuleHotel4, PageType: PageTypes.SA_BusinessesView },
                  { _Ord: 0, ID: "Descp", StaticTxt: "Details:", VarTxt: "<p>Add some formatted description here if you want the vertical template to be displayed, or delete it if you don't need the template</p>", Color: null, EntryType: EntryTypes.Txt, ModuleType: ModuleTypes.IsModuleHotel4, PageType: PageTypes.SA_BusinessesView }
                ]
              },
              {
                Items: [
                  { _Ord: 1, ID: "Title", StaticTxt: "Title:", VarTxt: "Room Services 2", Color: "#ffffff", BgColor: "rgb(0,0,0,0.5)", EntryType: EntryTypes.ALL, ModuleType: ModuleTypes.IsModuleHotel4, PageType: PageTypes.SA_BusinessesView },
                  { _Ord: 1, ID: "Img", StaticTxt: "Image:", Links: "../../../../assets/images/bg-images/defaults/hotel/room-services/bg2.jpg", VarTxt: null, EntryType: EntryTypes.Txt, ModuleType: ModuleTypes.IsModuleHotel4, PageType: PageTypes.SA_BusinessesView },
                  { _Ord: 1, ID: "BtTxt", StaticTxt: "Button text:", VarTxt: "REQUEST SERVICE", Color: "#ffffff", EntryType: EntryTypes.Txt, ModuleType: ModuleTypes.IsModuleHotel4, PageType: PageTypes.SA_BusinessesView },
                  { _Ord: 1, ID: "ExterLink", StaticTxt: "Set button link:", Links: "http://www.amadeosystems.com", EntryType: EntryTypes.Txt, ModuleType: ModuleTypes.IsModuleHotel4, PageType: PageTypes.SA_BusinessesView },
                  { _Ord: 1, ID: "Descp", StaticTxt: "Details:", VarTxt: "<p>Add some formatted description here if you want the vertical template to be displayed, or delete it if you don't need the template</p>", Color: null, EntryType: EntryTypes.Txt, ModuleType: ModuleTypes.IsModuleHotel4, PageType: PageTypes.SA_BusinessesView }
                ]
              },
              {
                Items: [
                  { _Ord: 2, ID: "Title", StaticTxt: "Title:", VarTxt: "Room Services 3", Color: "#ffffff", BgColor: "rgb(0,0,0,0.5)", EntryType: EntryTypes.ALL, ModuleType: ModuleTypes.IsModuleHotel4, PageType: PageTypes.SA_BusinessesView },
                  { _Ord: 2, ID: "Img", StaticTxt: "Image:", Links: "../../../../assets/images/bg-images/defaults/hotel/room-services/bg3.jpg", VarTxt: null, EntryType: EntryTypes.Txt, ModuleType: ModuleTypes.IsModuleHotel4, PageType: PageTypes.SA_BusinessesView },
                  { _Ord: 2, ID: "BtTxt", StaticTxt: "Button text:", VarTxt: "REQUEST SERVICE", Color: "#ffffff", EntryType: EntryTypes.Txt, ModuleType: ModuleTypes.IsModuleHotel4, PageType: PageTypes.SA_BusinessesView },
                  { _Ord: 2, ID: "ExterLink", StaticTxt: "Set button link:", Links: "http://www.amadeosystems.com", EntryType: EntryTypes.Txt, ModuleType: ModuleTypes.IsModuleHotel4, PageType: PageTypes.SA_BusinessesView },
                  { _Ord: 2, ID: "Descp", StaticTxt: "Details:", VarTxt: "<p>Add some formatted description here if you want the vertical template to be displayed, or delete it if you don't need the template</p>", Color: null, EntryType: EntryTypes.Txt, ModuleType: ModuleTypes.IsModuleHotel4, PageType: PageTypes.SA_BusinessesView }
                ]
              }
            ]
          },
          {
            ItemModule: { ID: "business-module-20000", StaticTxt: "Select module:", VarTxt: "BAR", EntryType: EntryTypes.Txt, ModuleType: ModuleTypes.IsModuleHotel5, PageType: PageTypes.SA_BusinessesView },
            Itemlist: [
              {
                Items: [
                  { _Ord: 0, ID: "Title", StaticTxt: "Title:", VarTxt: "Bar 1", Color: "#ffffff", BgColor: "rgb(0,0,0,0.5)", EntryType: EntryTypes.ALL, ModuleType: ModuleTypes.IsModuleHotel5, PageType: PageTypes.SA_BusinessesView },
                  { _Ord: 0, ID: "Img", StaticTxt: "Image:", Links: "../../../../assets/images/bg-images/defaults/hotel/bar/bg1.jpg", VarTxt: null, EntryType: EntryTypes.Txt, ModuleType: ModuleTypes.IsModuleHotel5, PageType: PageTypes.SA_BusinessesView },
                  { _Ord: 0, ID: "BtTxt", StaticTxt: "Button text:", VarTxt: "PLACE AN ORDER", Color: "#ffffff", EntryType: EntryTypes.Txt, ModuleType: ModuleTypes.IsModuleHotel5, PageType: PageTypes.SA_BusinessesView },
                  { _Ord: 0, ID: "ExterLink", StaticTxt: "Set button link:", Links: "http://www.amadeosystems.com", EntryType: EntryTypes.Txt, ModuleType: ModuleTypes.IsModuleHotel5, PageType: PageTypes.SA_BusinessesView },
                  { _Ord: 0, ID: "Descp", StaticTxt: "Details:", VarTxt: "<p>Add some formatted description here if you want the vertical template to be displayed, or delete it if you don't need the template</p>", Color: null, EntryType: EntryTypes.Txt, ModuleType: ModuleTypes.IsModuleHotel5, PageType: PageTypes.SA_BusinessesView }
                ]
              },
              {
                Items: [
                  { _Ord: 1, ID: "Title", StaticTxt: "Title:", VarTxt: "Bar 2", Color: "#ffffff", BgColor: "rgb(0,0,0,0.5)", EntryType: EntryTypes.ALL, ModuleType: ModuleTypes.IsModuleHotel5, PageType: PageTypes.SA_BusinessesView },
                  { _Ord: 1, ID: "Img", StaticTxt: "Image:", Links: "../../../../assets/images/bg-images/defaults/hotel/bar/bg2.jpg", VarTxt: null, EntryType: EntryTypes.Txt, ModuleType: ModuleTypes.IsModuleHotel5, PageType: PageTypes.SA_BusinessesView },
                  { _Ord: 1, ID: "BtTxt", StaticTxt: "Button text:", VarTxt: "PLACE AN ORDER", Color: "#ffffff", EntryType: EntryTypes.Txt, ModuleType: ModuleTypes.IsModuleHotel5, PageType: PageTypes.SA_BusinessesView },
                  { _Ord: 1, ID: "ExterLink", StaticTxt: "Set button link:", Links: "http://www.amadeosystems.com", EntryType: EntryTypes.Txt, ModuleType: ModuleTypes.IsModuleHotel5, PageType: PageTypes.SA_BusinessesView },
                  { _Ord: 1, ID: "Descp", StaticTxt: "Details:", VarTxt: "<p>Add some formatted description here if you want the vertical template to be displayed, or delete it if you don't need the template</p>", Color: null, EntryType: EntryTypes.Txt, ModuleType: ModuleTypes.IsModuleHotel5, PageType: PageTypes.SA_BusinessesView }
                ]
              },
              {
                Items: [
                  { _Ord: 2, ID: "Title", StaticTxt: "Title:", VarTxt: "Bar 3", Color: "#ffffff", BgColor: "rgb(0,0,0,0.5)", EntryType: EntryTypes.ALL, ModuleType: ModuleTypes.IsModuleHotel5, PageType: PageTypes.SA_BusinessesView },
                  { _Ord: 2, ID: "Img", StaticTxt: "Image:", Links: "../../../../assets/images/bg-images/defaults/hotel/bar/bg3.jpg", VarTxt: null, EntryType: EntryTypes.Txt, ModuleType: ModuleTypes.IsModuleHotel5, PageType: PageTypes.SA_BusinessesView },
                  { _Ord: 2, ID: "BtTxt", StaticTxt: "Button text:", VarTxt: "PLACE AN ORDER", Color: "#ffffff", EntryType: EntryTypes.Txt, ModuleType: ModuleTypes.IsModuleHotel5, PageType: PageTypes.SA_BusinessesView },
                  { _Ord: 2, ID: "ExterLink", StaticTxt: "Set button link:", Links: "http://www.amadeosystems.com", EntryType: EntryTypes.Txt, ModuleType: ModuleTypes.IsModuleHotel5, PageType: PageTypes.SA_BusinessesView },
                  { _Ord: 2, ID: "Descp", StaticTxt: "Details:", VarTxt: "<p>Add some formatted description here if you want the vertical template to be displayed, or delete it if you don't need the template</p>", Color: null, EntryType: EntryTypes.Txt, ModuleType: ModuleTypes.IsModuleHotel5, PageType: PageTypes.SA_BusinessesView }
                ]
              }
            ]
          },
          {
            ItemModule: { ID: "business-module-200000", StaticTxt: "Select module:", VarTxt: "Fitness", EntryType: EntryTypes.Txt, ModuleType: ModuleTypes.IsModuleHotel6, PageType: PageTypes.SA_BusinessesView },
            Itemlist: [
              {
                Items: [
                  { _Ord: 0, ID: "Title", StaticTxt: "Title:", VarTxt: "Fitness Center 1", Color: "#ffffff", BgColor: "rgb(0,0,0,0.5)", EntryType: EntryTypes.ALL, ModuleType: ModuleTypes.IsModuleHotel6, PageType: PageTypes.SA_BusinessesView },
                  { _Ord: 0, ID: "Img", StaticTxt: "Image:", Links: "../../../../assets/images/bg-images/defaults/hotel/fitness/bg1.jpg", VarTxt: null, EntryType: EntryTypes.Txt, ModuleType: ModuleTypes.IsModuleHotel6, PageType: PageTypes.SA_BusinessesView },
                  { _Ord: 0, ID: "BtTxt", StaticTxt: "Button text:", VarTxt: "ADD TO SCHEDULE", Color: "#ffffff", EntryType: EntryTypes.Txt, ModuleType: ModuleTypes.IsModuleHotel6, PageType: PageTypes.SA_BusinessesView },
                  { _Ord: 0, ID: "ExterLink", StaticTxt: "Set button link:", Links: "http://www.amadeosystems.com", EntryType: EntryTypes.Txt, ModuleType: ModuleTypes.IsModuleHotel6, PageType: PageTypes.SA_BusinessesView },
                  { _Ord: 0, ID: "Descp", StaticTxt: "Details:", VarTxt: "<p>Add some formatted description here if you want the vertical template to be displayed, or delete it if you don't need the template</p>", Color: null, EntryType: EntryTypes.Txt, ModuleType: ModuleTypes.IsModuleHotel6, PageType: PageTypes.SA_BusinessesView }
                ]
              },
              {
                Items: [
                  { _Ord: 1, ID: "Title", StaticTxt: "Title:", VarTxt: "Fitness Center 2", Color: "#ffffff", BgColor: "rgb(0,0,0,0.5)", EntryType: EntryTypes.ALL, ModuleType: ModuleTypes.IsModuleHotel6, PageType: PageTypes.SA_BusinessesView },
                  { _Ord: 1, ID: "Img", StaticTxt: "Image:", Links: "../../../../assets/images/bg-images/defaults/hotel/fitness/bg2.jpg", VarTxt: null, EntryType: EntryTypes.Txt, ModuleType: ModuleTypes.IsModuleHotel6, PageType: PageTypes.SA_BusinessesView },
                  { _Ord: 1, ID: "BtTxt", StaticTxt: "Button text:", VarTxt: "ADD TO SCHEDULE", Color: "#ffffff", EntryType: EntryTypes.Txt, ModuleType: ModuleTypes.IsModuleHotel6, PageType: PageTypes.SA_BusinessesView },
                  { _Ord: 1, ID: "ExterLink", StaticTxt: "Set button link:", Links: "http://www.amadeosystems.com", EntryType: EntryTypes.Txt, ModuleType: ModuleTypes.IsModuleHotel6, PageType: PageTypes.SA_BusinessesView },
                  { _Ord: 1, ID: "Descp", StaticTxt: "Details:", VarTxt: "<p>Add some formatted description here if you want the vertical template to be displayed, or delete it if you don't need the template</p>", Color: null, EntryType: EntryTypes.Txt, ModuleType: ModuleTypes.IsModuleHotel6, PageType: PageTypes.SA_BusinessesView }
                ]
              },
              {
                Items: [
                  { _Ord: 2, ID: "Title", StaticTxt: "Title:", VarTxt: "Fitness Center 3", Color: "#ffffff", BgColor: "rgb(0,0,0,0.5)", EntryType: EntryTypes.ALL, ModuleType: ModuleTypes.IsModuleHotel6, PageType: PageTypes.SA_BusinessesView },
                  { _Ord: 2, ID: "Img", StaticTxt: "Image:", Links: "../../../../assets/images/bg-images/defaults/hotel/fitness/bg3.jpg", VarTxt: null, EntryType: EntryTypes.Txt, ModuleType: ModuleTypes.IsModuleHotel6, PageType: PageTypes.SA_BusinessesView },
                  { _Ord: 2, ID: "BtTxt", StaticTxt: "Button text:", VarTxt: "ADD TO SCHEDULE", Color: "#ffffff", EntryType: EntryTypes.Txt, ModuleType: ModuleTypes.IsModuleHotel6, PageType: PageTypes.SA_BusinessesView },
                  { _Ord: 2, ID: "ExterLink", StaticTxt: "Set button link:", Links: "http://www.amadeosystems.com", EntryType: EntryTypes.Txt, ModuleType: ModuleTypes.IsModuleHotel6, PageType: PageTypes.SA_BusinessesView },
                  { _Ord: 2, ID: "Descp", StaticTxt: "Details:", VarTxt: "<p>Add some formatted description here if you want the vertical template to be displayed, or delete it if you don't need the template</p>", Color: null, EntryType: EntryTypes.Txt, ModuleType: ModuleTypes.IsModuleHotel6, PageType: PageTypes.SA_BusinessesView }
                ]
              }
            ]
          },
          {
            ItemModule: { ID: "business-module-20000000", StaticTxt: "Select module:", VarTxt: "SPA", EntryType: EntryTypes.Txt, ModuleType: ModuleTypes.IsModuleHotel7, PageType: PageTypes.SA_BusinessesView },
            Itemlist: [
              {
                Items: [
                  { _Ord: 0, ID: "Title", StaticTxt: "Title:", VarTxt: "Spa 1", Color: "#ffffff", BgColor: "rgb(0,0,0,0.5)", EntryType: EntryTypes.ALL, ModuleType: ModuleTypes.IsModuleHotel7, PageType: PageTypes.SA_BusinessesView },
                  { _Ord: 0, ID: "Img", StaticTxt: "Image:", Links: "../../../../assets/images/bg-images/defaults/hotel/spa/bg1.jpg", VarTxt: null, EntryType: EntryTypes.Txt, ModuleType: ModuleTypes.IsModuleHotel7, PageType: PageTypes.SA_BusinessesView },
                  { _Ord: 0, ID: "BtTxt", StaticTxt: "Button text:", VarTxt: "SCHEDULE APPOINTMENT", Color: "#ffffff", EntryType: EntryTypes.Txt, ModuleType: ModuleTypes.IsModuleHotel7, PageType: PageTypes.SA_BusinessesView },
                  { _Ord: 0, ID: "ExterLink", StaticTxt: "Set button link:", Links: "http://www.amadeosystems.com", EntryType: EntryTypes.Txt, ModuleType: ModuleTypes.IsModuleHotel7, PageType: PageTypes.SA_BusinessesView },
                  { _Ord: 0, ID: "Descp", StaticTxt: "Details:", VarTxt: "<p>Add some formatted description here if you want the vertical template to be displayed, or delete it if you don't need the template</p>", Color: null, EntryType: EntryTypes.Txt, ModuleType: ModuleTypes.IsModuleHotel7, PageType: PageTypes.SA_BusinessesView }
                ]
              },
              {
                Items: [
                  { _Ord: 1, ID: "Title", StaticTxt: "Title:", VarTxt: "Spa 2", Color: "#ffffff", BgColor: "rgb(0,0,0,0.5)", EntryType: EntryTypes.ALL, ModuleType: ModuleTypes.IsModuleHotel7, PageType: PageTypes.SA_BusinessesView },
                  { _Ord: 1, ID: "Img", StaticTxt: "Image:", Links: "../../../../assets/images/bg-images/defaults/hotel/spa/bg2.jpg", VarTxt: null, EntryType: EntryTypes.Txt, ModuleType: ModuleTypes.IsModuleHotel7, PageType: PageTypes.SA_BusinessesView },
                  { _Ord: 1, ID: "BtTxt", StaticTxt: "Button text:", VarTxt: "SCHEDULE APPOINTMENT", Color: "#ffffff", EntryType: EntryTypes.Txt, ModuleType: ModuleTypes.IsModuleHotel7, PageType: PageTypes.SA_BusinessesView },
                  { _Ord: 1, ID: "ExterLink", StaticTxt: "Set button link:", Links: "http://www.amadeosystems.com", EntryType: EntryTypes.Txt, ModuleType: ModuleTypes.IsModuleHotel7, PageType: PageTypes.SA_BusinessesView },
                  { _Ord: 1, ID: "Descp", StaticTxt: "Details:", VarTxt: "<p>Add some formatted description here if you want the vertical template to be displayed, or delete it if you don't need the template</p>", Color: null, EntryType: EntryTypes.Txt, ModuleType: ModuleTypes.IsModuleHotel7, PageType: PageTypes.SA_BusinessesView }
                ]
              },
              {
                Items: [
                  { _Ord: 2, ID: "Title", StaticTxt: "Title:", VarTxt: "Spa 3", Color: "#ffffff", BgColor: "rgb(0,0,0,0.5)", EntryType: EntryTypes.ALL, ModuleType: ModuleTypes.IsModuleHotel7, PageType: PageTypes.SA_BusinessesView },
                  { _Ord: 2, ID: "Img", StaticTxt: "Image:", Links: "../../../../assets/images/bg-images/defaults/hotel/spa/bg3.jpg", VarTxt: null, EntryType: EntryTypes.Txt, ModuleType: ModuleTypes.IsModuleHotel7, PageType: PageTypes.SA_BusinessesView },
                  { _Ord: 2, ID: "BtTxt", StaticTxt: "Button text:", VarTxt: "SCHEDULE APPOINTMENT", Color: "#ffffff", EntryType: EntryTypes.Txt, ModuleType: ModuleTypes.IsModuleHotel7, PageType: PageTypes.SA_BusinessesView },
                  { _Ord: 2, ID: "ExterLink", StaticTxt: "Set button link:", Links: "http://www.amadeosystems.com", EntryType: EntryTypes.Txt, ModuleType: ModuleTypes.IsModuleHotel7, PageType: PageTypes.SA_BusinessesView },
                  { _Ord: 2, ID: "Descp", StaticTxt: "Details:", VarTxt: "<p>Add some formatted description here if you want the vertical template to be displayed, or delete it if you don't need the template</p>", Color: null, EntryType: EntryTypes.Txt, ModuleType: ModuleTypes.IsModuleHotel7, PageType: PageTypes.SA_BusinessesView }
                ]
              }
            ]
          }
        ],
      CityGuide:
        [
          {
            ItemModule: { ID: "guide-module-1000", StaticTxt: "Select guide:", VarTxt: "Shopping", EntryType: EntryTypes.Txt, ModuleType: ModuleTypes.IsModuleGuide1, PageType: PageTypes.SA_BusinessesView },
            Itemlist: [
              {
                Items: [
                  { _Ord: 0, ID: "Geo", StaticTxt: "Guide Location:", Longitude: "0", Latitude: "0", EntryType: EntryTypes.Geo, ModuleType: ModuleTypes.IsModuleGuide1, PageType: PageTypes.SA_BusinessesView },
                  { _Ord: 0, ID: "Title2", StaticTxt: "Title:", VarTxt: "Shopping Area 1", Color: "#ffffff", BgColor: "rgb(0,0,0,0.5)", EntryType: EntryTypes.ALL, ModuleType: ModuleTypes.IsModuleGuide1, PageType: PageTypes.SA_BusinessesView },
                  { _Ord: 0, ID: "Img2", StaticTxt: "Image:", Links: "../../../../assets/images/bg-images/defaults/city-guide/shopping/bg1.jpg", VarTxt: null, EntryType: EntryTypes.Txt, ModuleType: ModuleTypes.IsModuleGuide1, PageType: PageTypes.SA_BusinessesView },
                  { _Ord: 0, ID: "BtTxt2", StaticTxt: "Button text:", VarTxt: "VISIT US", Color: "#ffffff", EntryType: EntryTypes.Txt, ModuleType: ModuleTypes.IsModuleGuide1, PageType: PageTypes.SA_BusinessesView },
                  { _Ord: 0, ID: "ExterLink2", StaticTxt: "Set button link:", Links: "http://www.amadeosystems.com", EntryType: EntryTypes.Txt, ModuleType: ModuleTypes.IsModuleGuide1, PageType: PageTypes.SA_BusinessesView },
                  { _Ord: 0, ID: "Descp2", StaticTxt: "Details:", VarTxt: "<p>Add some formatted description here if you want the vertical template to be displayed, or delete it if you don't need the template</p>", Color: null, EntryType: EntryTypes.Txt, ModuleType: ModuleTypes.IsModuleGuide1, PageType: PageTypes.SA_BusinessesView }
                ]
              },
              {
                Items: [
                  { _Ord: 1, ID: "Geo", StaticTxt: "Guide Location:", Longitude: "0", Latitude: "0", EntryType: EntryTypes.Geo, ModuleType: ModuleTypes.IsModuleGuide1, PageType: PageTypes.SA_BusinessesView },
                  { _Ord: 1, ID: "Title2", StaticTxt: "Title:", VarTxt: "Shopping Area 2", Color: "#ffffff", BgColor: "rgb(0,0,0,0.5)", EntryType: EntryTypes.ALL, ModuleType: ModuleTypes.IsModuleGuide1, PageType: PageTypes.SA_BusinessesView },
                  { _Ord: 1, ID: "Img2", StaticTxt: "Image:", Links: "../../../../assets/images/bg-images/defaults/city-guide/shopping/bg2.jpg", VarTxt: null, EntryType: EntryTypes.Txt, ModuleType: ModuleTypes.IsModuleGuide1, PageType: PageTypes.SA_BusinessesView },
                  { _Ord: 1, ID: "BtTxt2", StaticTxt: "Button text:", VarTxt: "EXPLORE", Color: "#ffffff", EntryType: EntryTypes.Txt, ModuleType: ModuleTypes.IsModuleGuide1, PageType: PageTypes.SA_BusinessesView },
                  { _Ord: 1, ID: "ExterLink2", StaticTxt: "Set button link:", Links: "http://www.amadeosystems.com", EntryType: EntryTypes.Txt, ModuleType: ModuleTypes.IsModuleGuide1, PageType: PageTypes.SA_BusinessesView },
                  { _Ord: 1, ID: "Descp2", StaticTxt: "Details:", VarTxt: "<p>Add some formatted description here if you want the vertical template to be displayed, or delete it if you don't need the template</p>", Color: null, EntryType: EntryTypes.Txt, ModuleType: ModuleTypes.IsModuleGuide1, PageType: PageTypes.SA_BusinessesView }
                ]
              },
              {
                Items: [
                  { _Ord: 2, ID: "Geo", StaticTxt: "Guide Location:", Longitude: "0", Latitude: "0", EntryType: EntryTypes.Geo, ModuleType: ModuleTypes.IsModuleGuide1, PageType: PageTypes.SA_BusinessesView },
                  { _Ord: 2, ID: "Title2", StaticTxt: "Title:", VarTxt: "Shopping Area 3", Color: "#ffffff", BgColor: "rgb(0,0,0,0.5)", EntryType: EntryTypes.ALL, ModuleType: ModuleTypes.IsModuleGuide1, PageType: PageTypes.SA_BusinessesView },
                  { _Ord: 2, ID: "Img2", StaticTxt: "Image:", Links: "../../../../assets/images/bg-images/defaults/city-guide/shopping/bg3.jpg", VarTxt: null, EntryType: EntryTypes.Txt, ModuleType: ModuleTypes.IsModuleGuide1, PageType: PageTypes.SA_BusinessesView },
                  { _Ord: 2, ID: "BtTxt2", StaticTxt: "Button text:", VarTxt: "EXPLORE", Color: "#ffffff", EntryType: EntryTypes.Txt, ModuleType: ModuleTypes.IsModuleGuide1, PageType: PageTypes.SA_BusinessesView },
                  { _Ord: 2, ID: "ExterLink2", StaticTxt: "Set button link:", Links: "http://www.amadeosystems.com", EntryType: EntryTypes.Txt, ModuleType: ModuleTypes.IsModuleGuide1, PageType: PageTypes.SA_BusinessesView },
                  { _Ord: 2, ID: "Descp2", StaticTxt: "Details:", VarTxt: "<p>Add some formatted description here if you want the vertical template to be displayed, or delete it if you don't need the template</p>", Color: null, EntryType: EntryTypes.Txt, ModuleType: ModuleTypes.IsModuleGuide1, PageType: PageTypes.SA_BusinessesView }
                ]
              }
            ]
          },
          {
            ItemModule: { ID: "guide-module-10000", StaticTxt: "Select module:", VarTxt: "Restaurants", EntryType: EntryTypes.Txt, ModuleType: ModuleTypes.IsModuleGuide2, PageType: PageTypes.SA_BusinessesView },
            Itemlist: [
              {
                Items: [
                  { _Ord: 0, ID: "Geo", StaticTxt: "Guide Location:", Longitude: "0", Latitude: "0", EntryType: EntryTypes.Geo, ModuleType: ModuleTypes.IsModuleGuide2, PageType: PageTypes.SA_BusinessesView },
                  { _Ord: 0, ID: "Title2", StaticTxt: "Title:", VarTxt: "Restaurant 1", Color: "#ffffff", BgColor: "rgb(0,0,0,0.5)", EntryType: EntryTypes.ALL, ModuleType: ModuleTypes.IsModuleGuide2, PageType: PageTypes.SA_BusinessesView },
                  { _Ord: 0, ID: "Img2", StaticTxt: "Image:", Links: "../../../../assets/images/bg-images/defaults/city-guide/restaurants/bg1.jpg", VarTxt: null, EntryType: EntryTypes.Txt, ModuleType: ModuleTypes.IsModuleGuide2, PageType: PageTypes.SA_BusinessesView },
                  { _Ord: 0, ID: "BtTxt2", StaticTxt: "Button text:", VarTxt: "PLACE AN ORDER", Color: "#ffffff", EntryType: EntryTypes.Txt, ModuleType: ModuleTypes.IsModuleGuide2, PageType: PageTypes.SA_BusinessesView },
                  { _Ord: 0, ID: "ExterLink2", StaticTxt: "Set button link:", Links: "http://www.amadeosystems.com", EntryType: EntryTypes.Txt, ModuleType: ModuleTypes.IsModuleGuide2, PageType: PageTypes.SA_BusinessesView },
                  { _Ord: 0, ID: "Descp2", StaticTxt: "Details:", VarTxt: "<p>Add some formatted description here if you want the vertical template to be displayed, or delete it if you don't need the template</p>", Color: null, EntryType: EntryTypes.Txt, ModuleType: ModuleTypes.IsModuleGuide2, PageType: PageTypes.SA_BusinessesView }
                ]
              },
              {
                Items: [
                  { _Ord: 1, ID: "Geo", StaticTxt: "Guide Location:", Longitude: "0", Latitude: "0", EntryType: EntryTypes.Geo, ModuleType: ModuleTypes.IsModuleGuide2, PageType: PageTypes.SA_BusinessesView },
                  { _Ord: 1, ID: "Title2", StaticTxt: "Title:", VarTxt: "PLACE AN ORDER", Color: "#ffffff", BgColor: "rgb(0,0,0,0.5)", EntryType: EntryTypes.ALL, ModuleType: ModuleTypes.IsModuleGuide2, PageType: PageTypes.SA_BusinessesView },
                  { _Ord: 1, ID: "Img2", StaticTxt: "Image:", Links: "../../../../assets/images/bg-images/defaults/city-guide/restaurants/bg2.jpg", VarTxt: null, EntryType: EntryTypes.Txt, ModuleType: ModuleTypes.IsModuleGuide2, PageType: PageTypes.SA_BusinessesView },
                  { _Ord: 1, ID: "BtTxt2", StaticTxt: "Button text:", VarTxt: "EXPLORE", Color: "#ffffff", EntryType: EntryTypes.Txt, ModuleType: ModuleTypes.IsModuleGuide2, PageType: PageTypes.SA_BusinessesView },
                  { _Ord: 1, ID: "ExterLink2", StaticTxt: "Set button link:", Links: "http://www.amadeosystems.com", EntryType: EntryTypes.Txt, ModuleType: ModuleTypes.IsModuleGuide2, PageType: PageTypes.SA_BusinessesView },
                  { _Ord: 1, ID: "Descp2", StaticTxt: "Details:", VarTxt: "<p>Add some formatted description here if you want the vertical template to be displayed, or delete it if you don't need the template</p>", Color: null, EntryType: EntryTypes.Txt, ModuleType: ModuleTypes.IsModuleGuide2, PageType: PageTypes.SA_BusinessesView }
                ]
              },
              {
                Items: [
                  { _Ord: 2, ID: "Geo", StaticTxt: "Guide Location:", Longitude: "0", Latitude: "0", EntryType: EntryTypes.Geo, ModuleType: ModuleTypes.IsModuleGuide2, PageType: PageTypes.SA_BusinessesView },
                  { _Ord: 2, ID: "Title2", StaticTxt: "Title:", VarTxt: "PLACE AN ORDER", Color: "#ffffff", BgColor: "rgb(0,0,0,0.5)", EntryType: EntryTypes.ALL, ModuleType: ModuleTypes.IsModuleGuide2, PageType: PageTypes.SA_BusinessesView },
                  { _Ord: 2, ID: "Img2", StaticTxt: "Image:", Links: "../../../../assets/images/bg-images/defaults/city-guide/restaurants/bg3.jpg", VarTxt: null, EntryType: EntryTypes.Txt, ModuleType: ModuleTypes.IsModuleGuide2, PageType: PageTypes.SA_BusinessesView },
                  { _Ord: 2, ID: "BtTxt2", StaticTxt: "Button text:", VarTxt: "EXPLORE", Color: "#ffffff", EntryType: EntryTypes.Txt, ModuleType: ModuleTypes.IsModuleGuide2, PageType: PageTypes.SA_BusinessesView },
                  { _Ord: 2, ID: "ExterLink2", StaticTxt: "Set button link:", Links: "http://www.amadeosystems.com", EntryType: EntryTypes.Txt, ModuleType: ModuleTypes.IsModuleGuide2, PageType: PageTypes.SA_BusinessesView },
                  { _Ord: 2, ID: "Descp2", StaticTxt: "Details:", VarTxt: "<p>Add some formatted description here if you want the vertical template to be displayed, or delete it if you don't need the template</p>", Color: null, EntryType: EntryTypes.Txt, ModuleType: ModuleTypes.IsModuleGuide2, PageType: PageTypes.SA_BusinessesView }
                ]
              }
            ]
          },
          {
            ItemModule: { ID: "guide-module-100000", StaticTxt: "Select module:", VarTxt: "Night Life", EntryType: EntryTypes.Txt, ModuleType: ModuleTypes.IsModuleGuide3, PageType: PageTypes.SA_BusinessesView },
            Itemlist: [
              {
                Items: [

                  { _Ord: 0, ID: "Geo", StaticTxt: "Guide Location:", Longitude: "0", Latitude: "0", EntryType: EntryTypes.Geo, ModuleType: ModuleTypes.IsModuleGuide3, PageType: PageTypes.SA_BusinessesView },
                  { _Ord: 0, ID: "Title2", StaticTxt: "Title:", VarTxt: "Night Life 1", Color: "#ffffff", BgColor: "rgb(0,0,0,0.5)", EntryType: EntryTypes.ALL, ModuleType: ModuleTypes.IsModuleGuide3, PageType: PageTypes.SA_BusinessesView },
                  { _Ord: 0, ID: "Img2", StaticTxt: "Image:", Links: "../../../../assets/images/bg-images/defaults/city-guide/night-life/bg1.jpg", VarTxt: null, EntryType: EntryTypes.Txt, ModuleType: ModuleTypes.IsModuleGuide3, PageType: PageTypes.SA_BusinessesView },
                  { _Ord: 0, ID: "BtTxt2", StaticTxt: "Button text:", VarTxt: "EXPLORE", Color: "#ffffff", EntryType: EntryTypes.Txt, ModuleType: ModuleTypes.IsModuleGuide3, PageType: PageTypes.SA_BusinessesView },
                  { _Ord: 0, ID: "ExterLink2", StaticTxt: "Set button link:", Links: "http://www.amadeosystems.com", EntryType: EntryTypes.Txt, ModuleType: ModuleTypes.IsModuleGuide3, PageType: PageTypes.SA_BusinessesView },
                  { _Ord: 0, ID: "Descp2", StaticTxt: "Details:", VarTxt: "<p>Add some formatted description here if you want the vertical template to be displayed, or delete it if you don't need the template</p>", Color: null, EntryType: EntryTypes.Txt, ModuleType: ModuleTypes.IsModuleGuide3, PageType: PageTypes.SA_BusinessesView }
                ]
              },
              {
                Items: [
                  { _Ord: 1, ID: "Geo", StaticTxt: "Guide Location:", Longitude: "0", Latitude: "0", EntryType: EntryTypes.Geo, ModuleType: ModuleTypes.IsModuleGuide3, PageType: PageTypes.SA_BusinessesView },
                  { _Ord: 1, ID: "Title2", StaticTxt: "Title:", VarTxt: "Night Life 2", Color: "#ffffff", BgColor: "rgb(0,0,0,0.5)", EntryType: EntryTypes.ALL, ModuleType: ModuleTypes.IsModuleGuide3, PageType: PageTypes.SA_BusinessesView },
                  { _Ord: 1, ID: "Img2", StaticTxt: "Image:", Links: "../../../../assets/images/bg-images/defaults/city-guide/night-life/bg2.jpg", VarTxt: null, EntryType: EntryTypes.Txt, ModuleType: ModuleTypes.IsModuleGuide3, PageType: PageTypes.SA_BusinessesView },
                  { _Ord: 1, ID: "BtTxt2", StaticTxt: "Button text:", VarTxt: "EXPLORE", Color: "#ffffff", EntryType: EntryTypes.Txt, ModuleType: ModuleTypes.IsModuleGuide3, PageType: PageTypes.SA_BusinessesView },
                  { _Ord: 1, ID: "ExterLink2", StaticTxt: "Set button link:", Links: "http://www.amadeosystems.com", EntryType: EntryTypes.Txt, ModuleType: ModuleTypes.IsModuleGuide3, PageType: PageTypes.SA_BusinessesView },
                  { _Ord: 1, ID: "Descp2", StaticTxt: "Details:", VarTxt: "<p>Add some formatted description here if you want the vertical template to be displayed, or delete it if you don't need the template</p>", Color: null, EntryType: EntryTypes.Txt, ModuleType: ModuleTypes.IsModuleGuide3, PageType: PageTypes.SA_BusinessesView }
                ]
              },
              {
                Items: [
                  { _Ord: 2, ID: "Geo", StaticTxt: "Guide Location:", Longitude: "0", Latitude: "0", EntryType: EntryTypes.Geo, ModuleType: ModuleTypes.IsModuleGuide3, PageType: PageTypes.SA_BusinessesView },
                  { _Ord: 2, ID: "Title2", StaticTxt: "Title:", VarTxt: "Night Life 3", Color: "#ffffff", BgColor: "rgb(0,0,0,0.5)", EntryType: EntryTypes.ALL, ModuleType: ModuleTypes.IsModuleGuide3, PageType: PageTypes.SA_BusinessesView },
                  { _Ord: 2, ID: "Img2", StaticTxt: "Image:", Links: "../../../../assets/images/bg-images/defaults/city-guide/night-life/bg3.jpg", VarTxt: null, EntryType: EntryTypes.Txt, ModuleType: ModuleTypes.IsModuleGuide3, PageType: PageTypes.SA_BusinessesView },
                  { _Ord: 2, ID: "BtTxt2", StaticTxt: "Button text:", VarTxt: "EXPLORE", Color: "#ffffff", EntryType: EntryTypes.Txt, ModuleType: ModuleTypes.IsModuleGuide3, PageType: PageTypes.SA_BusinessesView },
                  { _Ord: 2, ID: "ExterLink2", StaticTxt: "Set button link:", Links: "http://www.amadeosystems.com", EntryType: EntryTypes.Txt, ModuleType: ModuleTypes.IsModuleGuide3, PageType: PageTypes.SA_BusinessesView },
                  { _Ord: 2, ID: "Descp2", StaticTxt: "Details:", VarTxt: "<p>Add some formatted description here if you want the vertical template to be displayed, or delete it if you don't need the template</p>", Color: null, EntryType: EntryTypes.Txt, ModuleType: ModuleTypes.IsModuleGuide3, PageType: PageTypes.SA_BusinessesView }
                ]
              }
            ]
          },
          {
            ItemModule: { ID: "guide-module-2000", StaticTxt: "Select module:", VarTxt: "Kids Zone", EntryType: EntryTypes.Txt, ModuleType: ModuleTypes.IsModuleGuide4, PageType: PageTypes.SA_BusinessesView },
            Itemlist: [
              {
                Items: [
                  { _Ord: 0, ID: "Geo", StaticTxt: "Guide Location:", Longitude: "0", Latitude: "0", EntryType: EntryTypes.Geo, ModuleType: ModuleTypes.IsModuleGuide4, PageType: PageTypes.SA_BusinessesView },
                  { _Ord: 0, ID: "Title2", StaticTxt: "Title:", VarTxt: "Kids Zone 1", Color: "#ffffff", BgColor: "rgb(0,0,0,0.5)", EntryType: EntryTypes.ALL, ModuleType: ModuleTypes.IsModuleGuide4, PageType: PageTypes.SA_BusinessesView },
                  { _Ord: 0, ID: "Img2", StaticTxt: "Image:", Links: "../../../../assets/images/bg-images/defaults/city-guide/kids-zone/bg1.jpg", VarTxt: null, EntryType: EntryTypes.Txt, ModuleType: ModuleTypes.IsModuleGuide4, PageType: PageTypes.SA_BusinessesView },
                  { _Ord: 0, ID: "BtTxt2", StaticTxt: "Button text:", VarTxt: "EXPLORE", Color: "#ffffff", EntryType: EntryTypes.Txt, ModuleType: ModuleTypes.IsModuleGuide4, PageType: PageTypes.SA_BusinessesView },
                  { _Ord: 0, ID: "ExterLink2", StaticTxt: "Set button link:", Links: "http://www.amadeosystems.com", EntryType: EntryTypes.Txt, ModuleType: ModuleTypes.IsModuleGuide4, PageType: PageTypes.SA_BusinessesView },
                  { _Ord: 0, ID: "Descp2", StaticTxt: "Details:", VarTxt: "<p>Add some formatted description here if you want the vertical template to be displayed, or delete it if you don't need the template</p>", Color: null, EntryType: EntryTypes.Txt, ModuleType: ModuleTypes.IsModuleGuide4, PageType: PageTypes.SA_BusinessesView }
                ]
              },
              {
                Items: [
                  { _Ord: 1, ID: "Geo", StaticTxt: "Guide Location:", Longitude: "0", Latitude: "0", EntryType: EntryTypes.Geo, ModuleType: ModuleTypes.IsModuleGuide4, PageType: PageTypes.SA_BusinessesView },
                  { _Ord: 1, ID: "Title2", StaticTxt: "Title:", VarTxt: "Kids Zone 2", Color: "#ffffff", BgColor: "rgb(0,0,0,0.5)", EntryType: EntryTypes.ALL, ModuleType: ModuleTypes.IsModuleGuide4, PageType: PageTypes.SA_BusinessesView },
                  { _Ord: 1, ID: "Img2", StaticTxt: "Image:", Links: "../../../../assets/images/bg-images/defaults/city-guide/kids-zone/bg2.jpg", VarTxt: null, EntryType: EntryTypes.Txt, ModuleType: ModuleTypes.IsModuleGuide4, PageType: PageTypes.SA_BusinessesView },
                  { _Ord: 1, ID: "BtTxt2", StaticTxt: "Button text:", VarTxt: "EXPLORE", Color: "#ffffff", EntryType: EntryTypes.Txt, ModuleType: ModuleTypes.IsModuleGuide4, PageType: PageTypes.SA_BusinessesView },
                  { _Ord: 1, ID: "ExterLink2", StaticTxt: "Set button link:", Links: "http://www.amadeosystems.com", EntryType: EntryTypes.Txt, ModuleType: ModuleTypes.IsModuleGuide4, PageType: PageTypes.SA_BusinessesView },
                  { _Ord: 1, ID: "Descp2", StaticTxt: "Details:", VarTxt: "<p>Add some formatted description here if you want the vertical template to be displayed, or delete it if you don't need the template</p>", Color: null, EntryType: EntryTypes.Txt, ModuleType: ModuleTypes.IsModuleGuide4, PageType: PageTypes.SA_BusinessesView }
                ]
              },
              {
                Items: [
                  { _Ord: 2, ID: "Geo", StaticTxt: "Guide Location:", Longitude: "0", Latitude: "0", EntryType: EntryTypes.Geo, ModuleType: ModuleTypes.IsModuleGuide4, PageType: PageTypes.SA_BusinessesView },
                  { _Ord: 2, ID: "Title2", StaticTxt: "Title:", VarTxt: "Kids Zone 3", Color: "#ffffff", BgColor: "rgb(0,0,0,0.5)", EntryType: EntryTypes.ALL, ModuleType: ModuleTypes.IsModuleGuide4, PageType: PageTypes.SA_BusinessesView },
                  { _Ord: 2, ID: "Img2", StaticTxt: "Image:", Links: "../../../../assets/images/bg-images/defaults/city-guide/kids-zone/bg3.jpg", VarTxt: null, EntryType: EntryTypes.Txt, ModuleType: ModuleTypes.IsModuleGuide4, PageType: PageTypes.SA_BusinessesView },
                  { _Ord: 2, ID: "BtTxt2", StaticTxt: "Button text:", VarTxt: "EXPLORE", Color: "#ffffff", EntryType: EntryTypes.Txt, ModuleType: ModuleTypes.IsModuleGuide4, PageType: PageTypes.SA_BusinessesView },
                  { _Ord: 2, ID: "ExterLink2", StaticTxt: "Set button link:", Links: "http://www.amadeosystems.com", EntryType: EntryTypes.Txt, ModuleType: ModuleTypes.IsModuleGuide4, PageType: PageTypes.SA_BusinessesView },
                  { _Ord: 2, ID: "Descp2", StaticTxt: "Details:", VarTxt: "<p>Add some formatted description here if you want the vertical template to be displayed, or delete it if you don't need the template</p>", Color: null, EntryType: EntryTypes.Txt, ModuleType: ModuleTypes.IsModuleGuide4, PageType: PageTypes.SA_BusinessesView }
                ]
              }
            ]
          },
          {
            ItemModule: { ID: "guide-module-20000", StaticTxt: "Select module:", VarTxt: "Neighborhood", EntryType: EntryTypes.Txt, ModuleType: ModuleTypes.IsModuleGuide5, PageType: PageTypes.SA_BusinessesView },
            Itemlist: [
              {
                Items: [
                  { _Ord: 0, ID: "Geo", StaticTxt: "Guide Location:", Longitude: "0", Latitude: "0", EntryType: EntryTypes.Geo, ModuleType: ModuleTypes.IsModuleGuide5, PageType: PageTypes.SA_BusinessesView },
                  { _Ord: 0, ID: "Title2", StaticTxt: "Title:", VarTxt: "Neighborhood 1", Color: "#ffffff", BgColor: "rgb(0,0,0,0.5)", EntryType: EntryTypes.ALL, ModuleType: ModuleTypes.IsModuleGuide5, PageType: PageTypes.SA_BusinessesView },
                  { _Ord: 0, ID: "Img2", StaticTxt: "Image:", Links: "../../../../assets/images/bg-images/defaults/city-guide/neighborhood/bg1.jpg", VarTxt: null, EntryType: EntryTypes.Txt, ModuleType: ModuleTypes.IsModuleGuide5, PageType: PageTypes.SA_BusinessesView },
                  { _Ord: 0, ID: "BtTxt2", StaticTxt: "Button text:", VarTxt: "EXPLORE", Color: "#ffffff", EntryType: EntryTypes.Txt, ModuleType: ModuleTypes.IsModuleGuide5, PageType: PageTypes.SA_BusinessesView },
                  { _Ord: 0, ID: "ExterLink2", StaticTxt: "Set button link:", Links: "http://www.amadeosystems.com", EntryType: EntryTypes.Txt, ModuleType: ModuleTypes.IsModuleGuide5, PageType: PageTypes.SA_BusinessesView },
                  { _Ord: 0, ID: "Descp2", StaticTxt: "Details:", VarTxt: "<p>Add some formatted description here if you want the vertical template to be displayed, or delete it if you don't need the template</p>", Color: null, EntryType: EntryTypes.Txt, ModuleType: ModuleTypes.IsModuleGuide5, PageType: PageTypes.SA_BusinessesView }
                ]
              },
              {
                Items: [
                  { _Ord: 1, ID: "Geo", StaticTxt: "Guide Location:", Longitude: "0", Latitude: "0", EntryType: EntryTypes.Geo, ModuleType: ModuleTypes.IsModuleGuide5, PageType: PageTypes.SA_BusinessesView },
                  { _Ord: 1, ID: "Title2", StaticTxt: "Title:", VarTxt: "Neighborhood 2", Color: "#ffffff", BgColor: "rgb(0,0,0,0.5)", EntryType: EntryTypes.ALL, ModuleType: ModuleTypes.IsModuleGuide5, PageType: PageTypes.SA_BusinessesView },
                  { _Ord: 1, ID: "Img2", StaticTxt: "Image:", Links: "../../../../assets/images/bg-images/defaults/city-guide/neighborhood/bg2.jpg", VarTxt: null, EntryType: EntryTypes.Txt, ModuleType: ModuleTypes.IsModuleGuide5, PageType: PageTypes.SA_BusinessesView },
                  { _Ord: 1, ID: "BtTxt2", StaticTxt: "Button text:", VarTxt: "EXPLORE", Color: "#ffffff", EntryType: EntryTypes.Txt, ModuleType: ModuleTypes.IsModuleGuide5, PageType: PageTypes.SA_BusinessesView },
                  { _Ord: 1, ID: "ExterLink2", StaticTxt: "Set button link:", Links: "http://www.amadeosystems.com", EntryType: EntryTypes.Txt, ModuleType: ModuleTypes.IsModuleGuide5, PageType: PageTypes.SA_BusinessesView },
                  { _Ord: 1, ID: "Descp2", StaticTxt: "Details:", VarTxt: "<p>Add some formatted description here if you want the vertical template to be displayed, or delete it if you don't need the template</p>", Color: null, EntryType: EntryTypes.Txt, ModuleType: ModuleTypes.IsModuleGuide5, PageType: PageTypes.SA_BusinessesView }
                ]
              },
              {
                Items: [
                  { _Ord: 2, ID: "Geo", StaticTxt: "Guide Location:", Longitude: "0", Latitude: "0", EntryType: EntryTypes.Geo, ModuleType: ModuleTypes.IsModuleGuide5, PageType: PageTypes.SA_BusinessesView },
                  { _Ord: 2, ID: "Title2", StaticTxt: "Title:", VarTxt: "Neighborhood 3", Color: "#ffffff", BgColor: "rgb(0,0,0,0.5)", EntryType: EntryTypes.ALL, ModuleType: ModuleTypes.IsModuleGuide5, PageType: PageTypes.SA_BusinessesView },
                  { _Ord: 2, ID: "Img2", StaticTxt: "Image:", Links: "../../../../assets/images/bg-images/defaults/city-guide/neighborhood/bg3.jpg", VarTxt: null, EntryType: EntryTypes.Txt, ModuleType: ModuleTypes.IsModuleGuide5, PageType: PageTypes.SA_BusinessesView },
                  { _Ord: 2, ID: "BtTxt2", StaticTxt: "Button text:", VarTxt: "EXPLORE", Color: "#ffffff", EntryType: EntryTypes.Txt, ModuleType: ModuleTypes.IsModuleGuide5, PageType: PageTypes.SA_BusinessesView },
                  { _Ord: 2, ID: "ExterLink2", StaticTxt: "Set button link:", Links: "http://www.amadeosystems.com", EntryType: EntryTypes.Txt, ModuleType: ModuleTypes.IsModuleGuide5, PageType: PageTypes.SA_BusinessesView },
                  { _Ord: 2, ID: "Descp2", StaticTxt: "Details:", VarTxt: "<p>Add some formatted description here if you want the vertical template to be displayed, or delete it if you don't need the template</p>", Color: null, EntryType: EntryTypes.Txt, ModuleType: ModuleTypes.IsModuleGuide5, PageType: PageTypes.SA_BusinessesView }
                ]
              }
            ]
          },
          {
            ItemModule: { ID: "guide-module-200000", StaticTxt: "Select module:", VarTxt: "Must Know", EntryType: EntryTypes.Txt, ModuleType: ModuleTypes.IsModuleGuide6, PageType: PageTypes.SA_BusinessesView },
            Itemlist: [
              {
                Items: [
                  { _Ord: 0, ID: "Geo", StaticTxt: "Guide Location:", Longitude: "0", Latitude: "0", EntryType: EntryTypes.Geo, ModuleType: ModuleTypes.IsModuleGuide6, PageType: PageTypes.SA_BusinessesView },
                  { _Ord: 0, ID: "Title2", StaticTxt: "Title:", VarTxt: "Concept 1", Color: "#ffffff", BgColor: "rgb(0,0,0,0.5)", EntryType: EntryTypes.ALL, ModuleType: ModuleTypes.IsModuleGuide6, PageType: PageTypes.SA_BusinessesView },
                  { _Ord: 0, ID: "Img2", StaticTxt: "Image:", Links: "../../../../assets/images/bg-images/defaults/city-guide/must-know/bg1.jpg", VarTxt: null, EntryType: EntryTypes.Txt, ModuleType: ModuleTypes.IsModuleGuide6, PageType: PageTypes.SA_BusinessesView },
                  { _Ord: 0, ID: "BtTxt2", StaticTxt: "Button text:", VarTxt: "EXPLORE", Color: "#ffffff", EntryType: EntryTypes.Txt, ModuleType: ModuleTypes.IsModuleGuide6, PageType: PageTypes.SA_BusinessesView },
                  { _Ord: 0, ID: "ExterLink2", StaticTxt: "Set button link:", Links: "http://www.amadeosystems.com", EntryType: EntryTypes.Txt, ModuleType: ModuleTypes.IsModuleGuide6, PageType: PageTypes.SA_BusinessesView },
                  { _Ord: 0, ID: "Descp2", StaticTxt: "Details:", VarTxt: "<p>Add some formatted description here if you want the vertical template to be displayed, or delete it if you don't need the template</p>", Color: null, EntryType: EntryTypes.Txt, ModuleType: ModuleTypes.IsModuleGuide6, PageType: PageTypes.SA_BusinessesView }
                ]
              },
              {
                Items: [
                  { _Ord: 1, ID: "Geo", StaticTxt: "Guide Location:", Longitude: "0", Latitude: "0", EntryType: EntryTypes.Geo, ModuleType: ModuleTypes.IsModuleGuide6, PageType: PageTypes.SA_BusinessesView },
                  { _Ord: 1, ID: "Title2", StaticTxt: "Title:", VarTxt: "Concept 2", Color: "#ffffff", BgColor: "rgb(0,0,0,0.5)", EntryType: EntryTypes.ALL, ModuleType: ModuleTypes.IsModuleGuide6, PageType: PageTypes.SA_BusinessesView },
                  { _Ord: 1, ID: "Img2", StaticTxt: "Image:", Links: "../../../../assets/images/bg-images/defaults/city-guide/must-know/bg2.jpg", VarTxt: null, EntryType: EntryTypes.Txt, ModuleType: ModuleTypes.IsModuleGuide6, PageType: PageTypes.SA_BusinessesView },
                  { _Ord: 1, ID: "BtTxt2", StaticTxt: "Button text:", VarTxt: "EXPLORE", Color: "#ffffff", EntryType: EntryTypes.Txt, ModuleType: ModuleTypes.IsModuleGuide6, PageType: PageTypes.SA_BusinessesView },
                  { _Ord: 1, ID: "ExterLink2", StaticTxt: "Set button link:", Links: "http://www.amadeosystems.com", EntryType: EntryTypes.Txt, ModuleType: ModuleTypes.IsModuleGuide6, PageType: PageTypes.SA_BusinessesView },
                  { _Ord: 1, ID: "Descp2", StaticTxt: "Details:", VarTxt: "<p>Add some formatted description here if you want the vertical template to be displayed, or delete it if you don't need the template</p>", Color: null, EntryType: EntryTypes.Txt, ModuleType: ModuleTypes.IsModuleGuide6, PageType: PageTypes.SA_BusinessesView }
                ]
              },
              {
                Items: [
                  { _Ord: 2, ID: "Geo", StaticTxt: "Guide Location:", Longitude: "0", Latitude: "0", EntryType: EntryTypes.Geo, ModuleType: ModuleTypes.IsModuleGuide6, PageType: PageTypes.SA_BusinessesView },
                  { _Ord: 2, ID: "Title2", StaticTxt: "Title:", VarTxt: "Concept 3", Color: "#ffffff", BgColor: "rgb(0,0,0,0.5)", EntryType: EntryTypes.ALL, ModuleType: ModuleTypes.IsModuleGuide6, PageType: PageTypes.SA_BusinessesView },
                  { _Ord: 2, ID: "Img2", StaticTxt: "Image:", Links: "../../../../assets/images/bg-images/defaults/city-guide/must-know/bg3.jpg", VarTxt: null, EntryType: EntryTypes.Txt, ModuleType: ModuleTypes.IsModuleGuide6, PageType: PageTypes.SA_BusinessesView },
                  { _Ord: 2, ID: "BtTxt2", StaticTxt: "Button text:", VarTxt: "EXPLORE", Color: "#ffffff", EntryType: EntryTypes.Txt, ModuleType: ModuleTypes.IsModuleGuide6, PageType: PageTypes.SA_BusinessesView },
                  { _Ord: 2, ID: "ExterLink2", StaticTxt: "Set button link:", Links: "http://www.amadeosystems.com", EntryType: EntryTypes.Txt, ModuleType: ModuleTypes.IsModuleGuide6, PageType: PageTypes.SA_BusinessesView },
                  { _Ord: 2, ID: "Descp2", StaticTxt: "Details:", VarTxt: "<p>Add some formatted description here if you want the vertical template to be displayed, or delete it if you don't need the template</p>", Color: null, EntryType: EntryTypes.Txt, ModuleType: ModuleTypes.IsModuleGuide6, PageType: PageTypes.SA_BusinessesView }
                ]
              }
            ]
          },
          {
            ItemModule: { ID: "guide-module-20000000", StaticTxt: "Select module:", VarTxt: "Mechandises", EntryType: EntryTypes.Txt, ModuleType: ModuleTypes.IsModuleGuide7, PageType: PageTypes.SA_BusinessesView },
            Itemlist: [
              {
                Items: [
                  { _Ord: 0, ID: "Geo", StaticTxt: "Guide Location:", Longitude: "0", Latitude: "0", EntryType: EntryTypes.Geo, ModuleType: ModuleTypes.IsModuleGuide7, PageType: PageTypes.SA_BusinessesView },
                  { _Ord: 0, ID: "Title2", StaticTxt: "Title:", VarTxt: "Commodity 1", Color: "#ffffff", BgColor: "rgb(0,0,0,0.5)", EntryType: EntryTypes.ALL, ModuleType: ModuleTypes.IsModuleGuide7, PageType: PageTypes.SA_BusinessesView },
                  { _Ord: 0, ID: "Img2", StaticTxt: "Image:", Links: "../../../../assets/images/bg-images/defaults/city-guide/mechandises/bg1.jpg", VarTxt: null, EntryType: EntryTypes.Txt, ModuleType: ModuleTypes.IsModuleGuide7, PageType: PageTypes.SA_BusinessesView },
                  { _Ord: 0, ID: "BtTxt2", StaticTxt: "Button text:", VarTxt: "PLACE AN ORDER", Color: "#ffffff", EntryType: EntryTypes.Txt, ModuleType: ModuleTypes.IsModuleGuide7, PageType: PageTypes.SA_BusinessesView },
                  { _Ord: 0, ID: "ExterLink2", StaticTxt: "Set button link:", Links: "http://www.amadeosystems.com", EntryType: EntryTypes.Txt, ModuleType: ModuleTypes.IsModuleGuide7, PageType: PageTypes.SA_BusinessesView },
                  { _Ord: 0, ID: "Descp2", StaticTxt: "Details:", VarTxt: "<p>Add some formatted description here if you want the vertical template to be displayed, or delete it if you don't need the template</p>", Color: null, EntryType: EntryTypes.Txt, ModuleType: ModuleTypes.IsModuleGuide7, PageType: PageTypes.SA_BusinessesView }
                ]
              },
              {
                Items: [
                  { _Ord: 1, ID: "Geo", StaticTxt: "Guide Location:", Longitude: "0", Latitude: "0", EntryType: EntryTypes.Geo, ModuleType: ModuleTypes.IsModuleGuide7, PageType: PageTypes.SA_BusinessesView },
                  { _Ord: 1, ID: "Title2", StaticTxt: "Title:", VarTxt: "Commodity 2", Color: "#ffffff", BgColor: "rgb(0,0,0,0.5)", EntryType: EntryTypes.ALL, ModuleType: ModuleTypes.IsModuleGuide7, PageType: PageTypes.SA_BusinessesView },
                  { _Ord: 1, ID: "Img2", StaticTxt: "Image:", Links: "../../../../assets/images/bg-images/defaults/city-guide/mechandises/bg2.jpg", VarTxt: null, EntryType: EntryTypes.Txt, ModuleType: ModuleTypes.IsModuleGuide7, PageType: PageTypes.SA_BusinessesView },
                  { _Ord: 1, ID: "BtTxt2", StaticTxt: "Button text:", VarTxt: "PLACE AN ORDER", Color: "#ffffff", EntryType: EntryTypes.Txt, ModuleType: ModuleTypes.IsModuleGuide7, PageType: PageTypes.SA_BusinessesView },
                  { _Ord: 1, ID: "ExterLink2", StaticTxt: "Set button link:", Links: "http://www.amadeosystems.com", EntryType: EntryTypes.Txt, ModuleType: ModuleTypes.IsModuleGuide7, PageType: PageTypes.SA_BusinessesView },
                  { _Ord: 1, ID: "Descp2", StaticTxt: "Details:", VarTxt: "<p>Add some formatted description here if you want the vertical template to be displayed, or delete it if you don't need the template</p>", Color: null, EntryType: EntryTypes.Txt, ModuleType: ModuleTypes.IsModuleGuide7, PageType: PageTypes.SA_BusinessesView }
                ]
              },
              {
                Items: [
                  { _Ord: 2, ID: "Geo", StaticTxt: "Guide Location:", Longitude: "0", Latitude: "0", EntryType: EntryTypes.Geo, ModuleType: ModuleTypes.IsModuleGuide7, PageType: PageTypes.SA_BusinessesView },
                  { _Ord: 2, ID: "Title2", StaticTxt: "Title:", VarTxt: "Commodity 3", Color: "#ffffff", BgColor: "rgb(0,0,0,0.5)", EntryType: EntryTypes.ALL, ModuleType: ModuleTypes.IsModuleGuide7, PageType: PageTypes.SA_BusinessesView },
                  { _Ord: 2, ID: "Img2", StaticTxt: "Image:", Links: "../../../../assets/images/bg-images/defaults/city-guide/mechandises/bg3.jpg", VarTxt: null, EntryType: EntryTypes.Txt, ModuleType: ModuleTypes.IsModuleGuide7, PageType: PageTypes.SA_BusinessesView },
                  { _Ord: 2, ID: "BtTxt2", StaticTxt: "Button text:", VarTxt: "PLACE AN ORDER", Color: "#ffffff", EntryType: EntryTypes.Txt, ModuleType: ModuleTypes.IsModuleGuide7, PageType: PageTypes.SA_BusinessesView },
                  { _Ord: 2, ID: "ExterLink2", StaticTxt: "Set button link:", Links: "http://www.amadeosystems.com", EntryType: EntryTypes.Txt, ModuleType: ModuleTypes.IsModuleGuide7, PageType: PageTypes.SA_BusinessesView },
                  { _Ord: 2, ID: "Descp2", StaticTxt: "Details:", VarTxt: "<p>Add some formatted description here if you want the vertical template to be displayed, or delete it if you don't need the template</p>", Color: null, EntryType: EntryTypes.Txt, ModuleType: ModuleTypes.IsModuleGuide7, PageType: PageTypes.SA_BusinessesView }
                ]
              }
            ]
          }

        ]

    }

  public static _ChatsView: IItem[] =
    [
      { Enabled: true, ID: "OpColBg", StaticTxt: "Choose the operator color and background:", VarTxt: null, EntryType: EntryTypes.Color, Color: "#ffffff", BgColor: "#000000", ModuleType: ModuleTypes.NotAModule, PageType: PageTypes.SA_ChatView },
      { Enabled: true, ID: "GuestColBg", StaticTxt: "Choose the Guest color and background:", VarTxt: null, EntryType: EntryTypes.Color, Color: "#ffffff", BgColor: "#da0000", ModuleType: ModuleTypes.NotAModule, PageType: PageTypes.SA_ChatView },
      { Enabled: true, ID: "BtColBg", StaticTxt: "Choose the button color and background:", VarTxt: null, EntryType: EntryTypes.Color, Color: "#ffffff", BgColor: "#00fd00", ModuleType: ModuleTypes.NotAModule, PageType: PageTypes.SA_ChatView },
    ];

  public static _AccDrView: IItem[] =
    [
      { Enabled: true, ID: "EnableDescrip", StaticTxt: "Enable / disable the room guide description :", VarTxt: null, EntryType: EntryTypes.Txt, Color: "#ffffff", BgColor: "#000000", ModuleType: ModuleTypes.NotAModule, PageType: PageTypes.SA_DrAccView },
      { Enabled: true, ID: "EnableArrow", StaticTxt: "Enable / disable navigation arrows :", VarTxt: null, EntryType: EntryTypes.Txt, Color: "#ffffff", BgColor: "#000000", ModuleType: ModuleTypes.NotAModule, PageType: PageTypes.SA_DrAccView },
      { Enabled: true, ID: "EnablePaging", StaticTxt: "Enable / disable Pagination :", VarTxt: null, EntryType: EntryTypes.Txt, Color: "#ffffff", BgColor: "#000000", ModuleType: ModuleTypes.NotAModule, PageType: PageTypes.SA_DrAccView }
    ];


  public static _DoorList: IDoorList[] =
    [
      { DriD: 1, DrName: "101", DrImg: 'assets/images/ads/BoutiqHotel_HR_RGB.jpg', DrFunction: DOOR_FUNCTION.IsRoom, DrStatus: DOOR_STATE.NORMAL_CLOSE },
      { DriD: 2, DrName: "102", DrImg: 'assets/images/ads/education_HR_RGB.jpg', DrFunction: DOOR_FUNCTION.IsRoom, DrStatus: DOOR_STATE.NORMAL_CLOSE },
      { DriD: 3, DrName: "103", DrFunction: DOOR_FUNCTION.IsRoom, DrStatus: DOOR_STATE.NORMAL_CLOSE },
      { DriD: 4, DrName: "Entance", DrFunction: DOOR_FUNCTION.IsEntrance, DrStatus: DOOR_STATE.NORMAL_CLOSE },
      { DriD: 5, DrName: "Garage", DrLocation: "Building Level - 1 on the Right.", DrFunction: DOOR_FUNCTION.IsGarage, DrStatus: DOOR_STATE.NORMAL_CLOSE }

    ];


  public static _Person: IPerson =
    {
      PersonID: 1,
      _userId: 123456,
      _Servs: undefined,
      _Tzs: undefined,
      _ExpDate: new Date("2021-12-05T12:03:20.4521392+01:00"),
      _InitDate: new Date("2019-09-05T12:03:20.4521392+01:00"),
      _SerialNum: "123456789",
      _PersonType: PERSON_TYPE.GUEST,
      _GuestType: GUEST_TYPE.NEW_GUEST,
      _FirstName: "Peter",
      _LastName: "Smith",
      Gender: 0,
      isAuthenticated: false
    }

  public static _Properties: IMultiProperties[] =
    [
      {
        _SystemC: 123456,
        _Tok: "ef29ea91yxkizrhqjzq834uzq",
        _PropName: "Hotel GutenBrun",
        _PropAddress: "Baden",
        _Link: "./app-pro/proccess-auth/" + btoa("123456") + "/" + "somedata"
      },
      {
        _SystemC: 1234568,
        _Tok: "ef29ea91yxkizrhqjzq834uzq2",
        _PropName: "Hotel Steigenberger",
        _PropAddress: "Wien",
        _Link: "./app-pro/proccess-auth/" + btoa("1234568") + "/" + "somedata2"
      }

    ];


  /* All the data here should be the default for the style config, this will be replace by the related client request */
  /* all those data should not affect the security */
}